/**
 * gui_widgets_machinelogic.js
 *
 * "MachineLogic's widget library
 *
 * TODO (multiController): Refactor out the Application and UI Builder pages into their own separate
 * files in the same way that configuration_view.js now exists. This will be for
 * maintainability's sake. I can do this after multi controller is happy (mkosarek).
 *
 */
"use strict";

(function () {
  require('../colors.css');

  const $ = require('jQuery');
  const React = require('react');
  const ReactDOM = require('react-dom');
  const style = require('./style');
  const widgets = require('./widgets');
  const icons = require('../icons');
  const tooltips = require('./machinelogic_tooltips');
  const instructions = require('./instructions');
  const { uiBuilder } = require('../views');
  const environment = require('../environment');
  const helpers = require('../helpers');
  const machine_app_manager_view = require('../machine_app/views/machine_app_manager_view');
  const { configurationEditor } = require('../views');
  const view_widgets = require('./view_widgets');
  const { validatorErrorTypes, ValidatorErrorTypes, ApplicationTypes } = require('../machinelogic/constants');
  const ilib_widgets = require('./widgets');
  const instructionLabels = require('../constants/InstructionLabels');

  const { controlCenter, machineBuilder } = require("@ventionco/mm-machine-logic-robot");
  const {
    utils: {
      getUniqueClipNameFromApplication,
      isRobotReady: isRobotReadyWithoutEnvironment
    },
  } = controlCenter;

  const { autocompleteComponent } = require('./vse_ui/vse_components/base_components');
  const {
    cadCommandsButtonConfig,
    pendantCommandsButtonConfig
  } = require('../views/visual_sequence_editor/left_pane/commandButtonsConfig');
  const { LeftPane } = require('../views/visual_sequence_editor');

  let gLastRobotAssetTabActive = 0;

  function openSequence(library, application, sequence) {
    if(application.isReadOnly()) {
      $('.ml_editor').trigger('open_document', readOnlyDocument());
      return;
    }
    const _lSeqDocument = sequenceDocument(library, application, sequence);
    $('.ml_editor').trigger('open_document', _lSeqDocument);
  }

  /**
   * Entryway into the MachineLogic editor. Renders both the left sidebar and the right primary
   * view. When users select options in the left sidebar, the right view will be populated.
   *
   * The shape of the provided containers should look something like this:
   * ------------------------------------
   * |                                  |
   * |            pController           |
   * |----------------------------------|
   * |       |                          |
   * |       |                          |
   * |       |                          |
   * | pLeft |        pRight            |
   * |       |                          |
   * |       |                          |
   * |       |                          |
   * |       |                          |
   * ------------------------------------
   *
   */


  function editor(pEditorInterface) {
    const {
      // navigate is mandatory for the pendant and has no effect in the CAD.
      // This feels bad, yes, but it's the same behaviour as before.
      // The difference with before is that now we can't hide that it feels bad
      pendantNavigate = undefined,

      library,
      user,
      viewType,
      controllerContainer,
      leftContainer,
      rightContainer,
      getPlayerWidget,
      configurationProps,
      machineAppProps,
      uiBuilderProps,
      navigationProps,
      onApplicationUploaded
    } = pEditorInterface;

    // Render the document container into the the right container
    rightContainer.append(view_widgets.documentContainer(getPlayerWidget, machineAppProps));

    // Override left pane width for machine motion standalone
    if (environment.isOnPendant()) {
      leftContainer.addClass('left-pane-standalone');
    }

    const goBack = (app) => {
      if (app.getType() === ApplicationTypes.MachineApp) {
        navigationProps.openMachineAppApplicationView(app);
        return;
      }
      navigationProps.openApplicationLandingPage();
    };

    switch (viewType) {
      case 'configuration': {
        configurationEditor.configurationView(pendantNavigate, library, controllerContainer, leftContainer, configurationProps);
        break;
      }
      case 'machineapp': {
        machine_app_manager_view.machineAppManagerView(
          leftContainer,
          rightContainer,
          library,
          machineAppProps?.selectedAppType,
          machineAppProps?.selectedViewType,
          machineAppProps?.back
        );
        break;
      }
      case 'application': {
        const wiringMethods = {
          goBack,
          onAppSelected: navigationProps.openMachineLogicAppEditor,
          pendantNavigate,
          applicationErrorsWidget,
          openSequence,
          showConfirmationModal: widgets.showConfirmationModal,
          openDocument,
          onApplicationUploaded,
        };

        const commandButtonsConfig = environment.isOnCad() ? cadCommandsButtonConfig : pendantCommandsButtonConfig;

        // DELETEME: Must create a new application if there are none until landing page is in pendant.
        if (library.machineLogicAppList.length === 0) {
          library.selectApplication(library.newApplication());
        }

        ReactDOM.render(
          <LeftPane
            library={ library }
            commandButtonsConfig={commandButtonsConfig}
            wiringMethods={ wiringMethods }
            user={user}
          />, leftContainer[0]
        );
        leftContainer.markAsMachineLogicReactComponent('LeftPane');
        break;
      }
      case 'uibuilder': {
        leftContainer.append(
          UiBuilderView(library, user, machineAppProps, uiBuilderProps)
        );
        leftContainer.find('.ml_ui_tree_widget_item_ui.selected')[0].scrollIntoView({ block: 'center' });
        break;
      }
    }

    // This is a general and semi clean way of restoring the left pane because the machine app pane and application landing
    // pane hides it. Otherwise a "onLeavePane" callback for machine app would do.
    if (viewType !== 'machineapp' && viewType !== 'application_landing_page') {
      leftContainer.show();
    }
  }

  /**
   * Renders the ui builder.
   *
   * @param {import('./machinelogic/Library').Library} pLibrary The machine logic library
   * @param pUser
   * @param pMachineAppProps
   * @param pUiBuilderProps
   * @returns {jQuery} The sidebar containing the newly created ui builder.
   */
  function UiBuilderView(pLibrary, pUser, pMachineAppProps, pUiBuilderProps) {
    return $("<div>")
      .addClass("ml_library v_layout bordered spaced")
      .css({ overflowY: "auto", overflowX: "hidden" })
      .append(
        uiLibraryWidget(pLibrary, pUiBuilderProps, pMachineAppProps)
      );
  }

  let calibrationPartsWidget;
  let robotArraysWidget;
  let robotClipsWidget;

  function robotApplicationDocument(pLibrary, pApplication, pRobotAssetsWidgetParams, getTabIndex) {

    const _lTab = widgets.tab(getTabIndex, { "margin": "0 4px", "padding": "0" });

    const createCalibrationPartsWidget = ({ robotConfigs, p3DContext }) => {
      const { view: { ReferenceFrames }, model: { createEmptyFreedriveStatus } } = controlCenter;
      const { view: { CalibrationParts } } = machineBuilder;

      const _lWidget = $('<div class="ml_document v_layout spaced">').sortable({
        axis: 'y',
        distance: 4,
        // Please see ticket VentionCo/mm-vention-control#659
        disabled: true,
        tolerance: 'pointer',
        containment: '.ml_editor',
      }).css({ display: 'block' });

      let calibrationPartsComponent;
      if (environment.isOnCad()) {
        const robotUtils = p3DContext.robotUtils;
        calibrationPartsComponent = React.createElement(CalibrationParts, {
          robotAppsService: p3DContext.robotAppsService,
          getReferenceFrames: () => robotUtils.ArrayOf_VID_x_Name__getCalibrationParts()?.filter(c => !robotUtils.getRobotTypeFromVID(c.vid)),
          getReferenceFrameDefaultName: robotUtils.getCalibrationPartDefaultName
        });
      } else {
        calibrationPartsComponent = React.createElement(ReferenceFrames, {
          dispatch: pLibrary.robotAppsService.selectors.getDispatch(),
          getReferenceFrames: () => pLibrary.robotAppsService.selectors.getReferenceFramesByApplicationId(pApplication.mId),
          shouldDisplayReferenceFramesJogger: pLibrary.robotAppsService.selectors.shouldDisplayReferenceFramesJogger,
          tooltips,
          getReferenceFrameDefaultName: () => {},
          getRobotSpec: () => ({
            getJointLimits: () => [
              {
                min: -180,
                max: 180,
              }, {
                min: -180,
                max: 180,
              }, {
                min: -180,
                max: 180,
              }, {
                min: -180,
                max: 180,
              }, {
                min: -180,
                max: 180,
              }, {
                min: -180,
                max: 180,
              }
            ]
          }),
          getRobotState: () => ({
            getPosition: () => {
              const position = pLibrary.robotAppsService.selectors.getRobotCartesianPositionInMM();

              return {
                mP: {
                  x: position?.x || 0,
                  y: position?.y || 0,
                  z: position?.z || 0,
                }
              };
            },
            getRotation: () => {
              const rotation = pLibrary.robotAppsService.selectors.getRobotCartesianRotationInDeg();

              return {
                mP: {
                  x: rotation?.x || 0,
                  y: rotation?.y || 0,
                  z: rotation?.z || 0,
                }
              };
            },
            getJointAngles: () => pLibrary.robotAppsService.selectors.getRobotJointStatesInDeg() || [0, 0, 0, 0, 0, 0],
            getFreedriveStatus: () => pLibrary.robotAppsService.selectors.getFreedriveStatus() || createEmptyFreedriveStatus(),
            getJoggerSpeedPercentage: () => pLibrary.robotAppsService.selectors.getJoggerSpeedPercentage(),
          }),
          robotType: robotConfigs[0].getType(),
        });
      }
      ReactDOM.render(calibrationPartsComponent, _lWidget[0]);

      pLibrary.addListener({
        onApplicationRemoved: application => application.mUUID === pApplication.mUUID && ReactDOM.unmountComponentAtNode(_lWidget[0])
      });
      _lWidget.onMount = function() {
        ReactDOM.render(calibrationPartsComponent, _lWidget[0]);
      };

      _lWidget.onUnmount = function() {
        ReactDOM.unmountComponentAtNode(_lWidget[0]);
      };

      _lWidget.on('remove', () => ReactDOM.unmountComponentAtNode(_lWidget[0]));

      return _lWidget;
    };
    const createRobotArraysWidget = ({ pApplication, p3DContext }) => {
      const { view: { RobotArrays: controlCenterRobotArrays } } = controlCenter;
      const { view: { RobotArrays: machineBuilderRobotArrays } } = machineBuilder;

      const _lWidget = $('<div class="ml_document v_layout spaced">').sortable({
        axis: 'y',
        distance: 4,
        // Please see ticket VentionCo/mm-vention-control#659
        disabled: true,
        tolerance: 'pointer',
        containment: '.ml_editor',
      }).css({ display: 'block' });

      let robotArraysComponent;
      if (environment.isOnCad()) {
        robotArraysComponent = React.createElement(machineBuilderRobotArrays, { tooltips, robotAppsService: p3DContext.robotAppsService, getRobotParametersArrays: () => pApplication.robotParameters.arrays, getRobotArrayNamesUsed: () => pApplication.mSequences.map(s => s.mInstructions.map(i => i.mParameters?.arrayName)).flat() });
      } else {
        robotArraysComponent = React.createElement(controlCenterRobotArrays, {
          getRobotAppServiceStateValue: pLibrary.robotAppsService.selectors.getRobotAppServiceStateValue,
          dispatch: pLibrary.robotAppsService.selectors.getDispatch(),
          /** @type {() => import('@ventionco/mm-machine-logic-robot').ArrayEditorState[]} */
          getRobotParametersArrays: () => pApplication.robotParameters.arrays,
          getRobotArrayNamesUsed: () => pApplication.mSequences.map(s => s.mInstructions.map(i => i.mParameters?.arrayName)).flat()
        });
      }

      ReactDOM.render(robotArraysComponent, _lWidget[0]);

      pLibrary.addListener({
        onApplicationRemoved: application => application.mUUID === pApplication.mUUID && ReactDOM.unmountComponentAtNode(_lWidget[0])
      });

      _lWidget.onMount = function() {
        ReactDOM.render(robotArraysComponent, _lWidget[0]);
      };

      _lWidget.onUnmount = function() {
        ReactDOM.unmountComponentAtNode(_lWidget[0]);
      };

      _lWidget.on('remove', () => ReactDOM.unmountComponentAtNode(_lWidget[0]));

      return _lWidget;
    };
    const createRobotClipsWidget = ({ robotConfigs, pApplication, p3DContext }) => {
      const { view: { RobotClips: controlCenterRobotClips }, model: { createEmptyFreedriveStatus } } = controlCenter;
      const { view: { RobotClips: machineBuilderRobotClips } } = machineBuilder;

      const _lWidget = $('<div class="ml_document v_layout spaced">').sortable({
        axis: 'y',
        distance: 4,
        // Please see ticket VentionCo/mm-vention-control#659
        disabled: true,
        tolerance: 'pointer',
        containment: '.ml_editor',
      }).css({ display: 'inline' });

      let robotClipsComponent;

      if (environment.isOnCad()) {
        const { robotUtils } = p3DContext;
        const getRobotActuatorVID = robotConfigVID => parseInt(Object.keys(robotConfigs.find(r => parseInt(r.mVID) === parseInt(robotConfigVID))?.mRobotActuators || {})[0]) || null;
        const manipRobotState = p3DContext.getManipulatorOfType("manip-robot").mState;
        const RobotClipsCAD = React.createElement(machineBuilderRobotClips, { robotConfigs, pApplication, p3DContext, manipRobotState, tooltips, robotAppsService: p3DContext.robotAppsService, getJointLimits: () => p3DContext.robotUtils.getRobotJointLimits(getRobotActuatorVID(robotConfigs[0].mVID)), getRobotClips: () => pApplication.robotParameters.clips, getRobotClipIdsUsed: () => pApplication.mSequences.map(s => s.mInstructions.map(i => i.mParameters?.clipId)).flat(), getUniqueClipName: getUniqueClipNameFromApplication(pApplication), validatePoseWaypoint: pose => manipRobotState.validatePoseWaypoint({ vid: parseInt(Object.keys(robotConfigs[0].mRobotActuators)[0]), pose }), getDefaultTeachingReferenceFrame: robotId => robotUtils.createTeachingReferenceFrameAtRobotBase(getRobotActuatorVID(robotId)), });
        robotClipsComponent = RobotClipsCAD;
      } else {
        const dispatch = pLibrary.robotAppsService.selectors.getDispatch();
        const jogger = {
          getPosition: () => {
            const position = pLibrary.robotAppsService.selectors.getRobotCartesianPositionInMM();

            return {
              mP: {
                x: position?.x || 0,
                y: position?.y || 0,
                z: position?.z || 0,
              },
            };
          },
          getRotation: () => {
            const rotation = pLibrary.robotAppsService.selectors.getRobotCartesianRotationInDeg();

            return {
              mP: {
                x: rotation?.x || 0,
                y: rotation?.y || 0,
                z: rotation?.z || 0,
              },
            };
          },
          getJointAngles: () => pLibrary.robotAppsService.selectors.getRobotJointStatesInDeg() || [0, 0, 0, 0, 0, 0],
          getFreedriveStatus: () => pLibrary.robotAppsService.selectors.getFreedriveStatus() || createEmptyFreedriveStatus(),
          onJoggerPoseTranslationMouseDown: (letter, value) =>
            dispatch("RobotClips/onJoggerPoseTranslationMouseDown", {
              letter,
              value,
            }),
          onJoggerPoseRotationMouseDown: (letter, value) =>
            dispatch("RobotClips/onJoggerPoseRotationMouseDown", {
              letter,
              value,
            }),
          onJoggerJointArrowMouseDown: (index, delta) =>
            dispatch("RobotClips/onJoggerJointArrowMouseDown", { index, delta }),
          onJoggerArrowMouseUp: () =>
            dispatch("RobotClips/onJoggerArrowMouseUp"),
          onSpeedSliderChange: (joggerSpeedPercentage) =>
            dispatch("RobotInstructionEditable/JOGGER_SPEED_SLIDER_CHANGED", {
              joggerSpeedPercentage,
            }),
          onEnableFreedriveButtonClick: () =>
            dispatch("RobotClips/onEnableFreedriveButtonClick"),
          onDisableFreedriveButtonClick: () =>
            dispatch("RobotClips/onDisableFreedriveButtonClick"),
          onToggleConstraintButtonClick: (constraintIndex) =>
            dispatch("RobotClips/onToggleConstraintButtonClick", {
              constraintIndex,
            }),
        };

        const RobotClipsPENDANT = React.createElement(controlCenterRobotClips, {
          application: pApplication,
          jogger,
          robotAppsService: pLibrary.robotAppsService,
          robotConfigs: robotConfigs[0],
          tooltips,
          getRobotClips: () => pApplication.robotParameters.clips,
          getRobotClipIdsUsed: () => pApplication.mSequences.map(s => s.mInstructions.map(i => i.mParameters?.clipId)).flat(),
          getUniqueClipName: getUniqueClipNameFromApplication(pApplication),
        });
        robotClipsComponent = RobotClipsPENDANT;
      }
      ReactDOM.render(robotClipsComponent, _lWidget[0]);


      pLibrary.addListener({
        onApplicationRemoved: application => application.mUUID === pApplication.mUUID && ReactDOM.unmountComponentAtNode(_lWidget[0])
      });

      _lWidget.on('remove', () => ReactDOM.unmountComponentAtNode(_lWidget[0]));

      _lWidget.onMount = function() {
        ReactDOM.render(robotClipsComponent, _lWidget[0]);
      };

      _lWidget.onUnmount = function() {
        ReactDOM.unmountComponentAtNode(_lWidget[0]);
      };

      return _lWidget;
    };
    const createInstructionTooltip = (key) => {
      return $('<span class="ml_tooltip_icon ml_label_icon ' + icons.unknown + '"/>').click(
        () => {
          tooltips.showTips(key);
        }
      );
    };

    calibrationPartsWidget = createCalibrationPartsWidget({ ...pRobotAssetsWidgetParams, pApplication });
    robotArraysWidget = createRobotArraysWidget({ ...pRobotAssetsWidgetParams, pApplication });
    robotClipsWidget = createRobotClipsWidget({ robotClipsWidget, ...pRobotAssetsWidgetParams, pApplication });

    // Add pages to the tab
    const robotAppsService = pLibrary.getRobotAppsService();
    !window.MACHINE_MOTION && _lTab.addTab(widgets.tabLink('Robot Paths', robotClipsWidget, createInstructionTooltip('robot_sequences')), () => {
      robotAppsService.send('RobotAssets/ROBOTCLIPS_TAB_CLICKED'); });
    !window.MACHINE_MOTION && _lTab.addTab(widgets.tabLink('Robot Arrays', robotArraysWidget, createInstructionTooltip('robot_arrays')),
      () => { robotAppsService.send('RobotAssets/ROBOTARRAYS_TAB_CLICKED'); });
    !window.MACHINE_MOTION && _lTab.addTab(widgets.tabLink('Digital Calibration Tools', calibrationPartsWidget, createInstructionTooltip('digital_calibration_tools')), () => pLibrary?.m3DContext?.robotAppsService.send('RobotAssets/CALIBRATIONPARTS_TAB_CLICKED'));
    const robotApplicationDocument = new view_widgets.Document(pApplication, _lTab, [], 'Robot Assets');
    return robotApplicationDocument;
  }

  function readOnlyDocument() {
    const widget = $('<div>')
      .css({
        'display': 'flex', 'flex-direction': 'column',
        'align-items': 'center', 'justify-content': 'center',
        'padding': '1rem',
        'height': '100%',
        'opacity': 0.8,
        'font-size': '24px'
      })
      .append(
        $('<div>').text('Read Only Application').css({ 'color': '#D9534F', 'font-size': '36px', 'padding-bottom': '2rem' }),
        $('<div>').text('This application is read-only, and can only be modified on vention.io.').css({'padding-bottom':'0.5rem'}),
        $('<div>').text('Go to the Application Launcher page to run it.').css({'padding-bottom':'0.5rem'}),
      );
    const object = {
      getName: () => 'Read Only',
      readOnly: true
    };
    const readOnlyDoc = new view_widgets.Document(object, widget, []);

    return readOnlyDoc;
  }


  function applicationDocument(pApplication, focusedParamType, focusedParamName) {
    if(pApplication.isReadOnly()) { return readOnlyDocument(); }

    const lAppParametersCards = {};
    const lTabs = Object.freeze({
      VARIABLES : 'Variables',
      FUNCTIONS : 'Functions'
    });
    let lCurrentTab = lTabs.VARIABLES;

    if (focusedParamType) {
      if (focusedParamType === 'variable') {
        lCurrentTab = lTabs.VARIABLES;
      } else if (focusedParamType === 'function') {
        lCurrentTab = lTabs.FUNCTIONS;
      }
    }

    // HTML Hierarchy

    // lAppParametersPane
    // |_ lTabsContainer
    //   |_ lVariablesTab
    //   |_ lFunctionsTab
    // |_ lVariablesContent
    //   |_ lVariablesHeader, lVariablesContainer, lAddVariableButton
    //   |_ lInputAsVariableHeader, lInputAsVariablesContainer, lAddInputAsVariableButton
    // |_ lFunctionsContent
    //   |_ lLambdaHeader, lLambdasContainer, lAddLambdaButton

    // We show the right Content based on the tab selected and hide the rest.

    const lAppParametersPane = $('<div>').addClass('application_params_pane');

    // Tabs
    const lTabsContainer = $('<div>').addClass('ml_variables_tab');

    // Variable tab
    const lVariablesTab = $('<div>')
      .on('click', () => { lCurrentTab = lTabs.VARIABLES; lUpdateAppParametersPane(); })
      .addClass('ml_variables_tab');
    $('<div>').text('Variables').appendTo(lVariablesTab);
    $('<span>').addClass(`ml_tooltip_icon ml_label_icon ${icons.unknown}`).on( 'click', function () { tooltips.showTips('variables'); }).appendTo(lVariablesTab);

    // Functions tab
    const lFunctionsTab = $('<div>')
      .on('click', () => { lCurrentTab = lTabs.FUNCTIONS; lUpdateAppParametersPane(); })
      .addClass('ml_variables_tab');
    $('<div>').text('Functions').appendTo(lFunctionsTab);
    $('<span>').addClass(`ml_tooltip_icon ml_label_icon ${icons.unknown}`).on( 'click', function () { tooltips.showTips('functions'); }).appendTo(lFunctionsTab);

    // Content
    // Variables Content
    const lVariablesContent = $('<div>');

    // Regular Variables
    const lVariableHeader = $('<div>').addClass('application_param_header').text('Variables');
    const lVariablesContainer = $('<div>');
    const lAddVariableButton = widgets.buttonIcon(null, 'Add variable', icons.addPlus, 'Add a variable', function() { pApplication.addApplicationParameter('const');})
      .css({ 'align-self': 'flex-start', margin: '1rem 0 30px 0'});

    // Inputs as Variables
    const lInputAsVariableHeader = $('<div>').addClass('application_param_header').text('Inputs as Variables');
    const lInputAsVariablesContainer = $('<div>');
    const lAddInputAsVariableButton = widgets.buttonIcon(null, 'Add variable tracking an input state', icons.addPlus, 'Add a variable pointing to an input', function() {
      if (pApplication.mLibrary.getConfigManager().listInputs().length == 0) {
        widgets.messageBox('Please configure an input before adding it as a variable.', 'error');
      }
      else { pApplication.addApplicationParameter('input'); }
    }).css({ margin: '1rem 0px' });

    // Functions Content
    const lFunctionsContent = $('<div>');

    // Lambdas
    const lLambdaHeader = $('<div>').addClass('application_param_header').text('Lambda Functions');
    const lLambdasContainer = $('<div>');
    const lAddLambdaButton = widgets.buttonIcon(null, 'Add lambda function', icons.addPlus, 'Add a function', function() { pApplication.addApplicationParameter('lambda');})
      .css({ 'align-self': 'flex-start', margin: '1rem 0 30px 0'});

    // Assemble Widget
    lAppParametersPane.append([
      lTabsContainer.append(
        lVariablesTab,
        lFunctionsTab,
      ),
      lVariablesContent.append(
        lVariableHeader, lVariablesContainer, lAddVariableButton,
        lInputAsVariableHeader, lInputAsVariablesContainer, lAddInputAsVariableButton
      ),
      lFunctionsContent.append(
        lLambdaHeader, lLambdasContainer, lAddLambdaButton,
      )
    ]);

    // Helper functions
    function addVariable (pVariableObject, focusedParamName) {
      const lVariableWidget = applicationParameterWidget(pApplication, pVariableObject);
      lAppParametersCards[pVariableObject.id] = lVariableWidget;
      if (pVariableObject.type == 'const') {
        lVariablesContainer.append(lVariableWidget);
      } else if (pVariableObject.type == 'lambda') {
        lLambdasContainer.append(lVariableWidget);
      } else if (pVariableObject.type == 'input') {
        lInputAsVariablesContainer.append(lVariableWidget);
      }

      if (focusedParamName !== undefined && pVariableObject.name === focusedParamName) {
        lVariableWidget.addClass('focus-on-open');
      }
    }

    function lUpdateAppParametersPane() {
      // Reset
      lVariablesTab.removeClass('ml_tab_selected');
      lFunctionsTab.removeClass('ml_tab_selected');
      lVariablesContent.hide();
      lFunctionsContent.hide();

      // Update
      switch(lCurrentTab) {
        case lTabs.VARIABLES: {
          lVariablesTab.addClass('ml_tab_selected');
          lVariablesContent.show();
          break;
        }
        case lTabs.FUNCTIONS: {
          lFunctionsTab.addClass('ml_tab_selected');
          lFunctionsContent.show();
          break;
        }
        default: console.error('Unknown tab');
      }
    }

    // Load all variables <-> applicationParameters
    pApplication.getParametersObject().toJson(true).forEach(function(pVariableObject) { addVariable(pVariableObject, focusedParamName); });
    lUpdateAppParametersPane();

    // Define Listeners
    const lApplicationListener = {
      onApplicationParameterAdded: function(pVariableObject) { addVariable(pVariableObject); },
      onApplicationParameterRemoved: function(pParameter) {
        if (pParameter && lAppParametersCards.hasOwnProperty(pParameter.id)) {
          lAppParametersCards[pParameter.id].remove();
        }
      }
    };

    // Attach Listeners
    pApplication.addListener(lApplicationListener);
    // Detach Listeners
    lAppParametersPane.on('remove', function callbackOnRemove() {
      pApplication.removeListener(lApplicationListener);
    });

    const lAppDoc = new view_widgets.Document(pApplication, lAppParametersPane, []);

    lAppDoc.appParamCards = lAppParametersCards;
    return lAppDoc;
  }

  function sequenceDocument(pLibrary, pApplication, pSequence) {
    let _lFrom;
    let _lTo;
    const lMachineAppSequenceIsReadonly = pApplication.mIsMachineApp && pSequence.isInitialSequence();
    const _renumber = function() {
      _lSeqWidget.find('.ml_instruction').each(function(pIndex, pElement) {
        $(pElement).find('.ml_number').text(pIndex + 1);
      });
    };
    const _readOnly = function() {
      _lSeqWidget.find('.ml_instruction').each(function(pIndex, pElement) {
        $(pElement).addClass('machine_app_read_only');
        $(pElement).find('.ml_tooltip_icon').css('pointer-events', 'auto');
        $(pElement).find('.ml_select_widget').addClass('machine_app_locked_sequence');
        $(pElement).find('.ml_parameter_widget').addClass('ml_disabled_app_param');
        $(pElement).find('.ml_autocomplete_component').addClass('ml_disabled_app_param');
        $(pElement).find('div[contenteditable="true"].ml_log_message_box').attr('contenteditable', 'false');
        $(pElement).find('.ml_close').remove();
      });
    };
    const _makeInstructionsNotEditable = function() {
      if(lMachineAppSequenceIsReadonly) { return; }
      _lSeqWidget.find('.ml_instruction').each(function(pIndex, pElement) {
        $(pElement).css('pointer-events', 'none');
        $(pElement).find('.ml_select_widget').addClass('ml_disabled_app_param');
        $(pElement).find('.ml_parameter_widget').addClass('ml_disabled_app_param');
        $(pElement).find('.ml_autocomplete_component').addClass('ml_disabled_app_param');
        $(pElement).find('div[contenteditable="true"].ml_log_message_box').attr('contenteditable', 'false');
        $(pElement).find('.ml_close').hide();
      });
    };
    const _makeInstructionsEditable = function() {
      if(lMachineAppSequenceIsReadonly) { return; }
      _lSeqWidget.find('.ml_instruction').each(function(pIndex, pElement) {
        $(pElement).css('pointer-events', '');
        $(pElement).find('.ml_select_widget').removeClass('ml_disabled_app_param');
        $(pElement).find('.ml_parameter_widget').removeClass('ml_disabled_app_param');
        $(pElement).find('.ml_autocomplete_component').removeClass('ml_disabled_app_param');
        $(pElement).find('div[contenteditable="false"].ml_log_message_box').attr('contenteditable', 'true');
        $(pElement).find('.ml_close').show();
      });
    };
    const _lSeqListener = {
      onInstructionAdded: function(pInstruction, pIndex) {
        // remove hint message if present
        lHintText && lHintText.remove();
        const _lInst = instructions.create(pLibrary, pApplication, pSequence, pInstruction);
        _lInst.on('click', function () { pSequence.setSelectedInstruction(pInstruction, undefined, 'instructionCard' ); });
        if(undefined == pIndex || pIndex >= _lSeqWidget.children().length) {
          _lSeqWidget.append(_lInst);
          _lInst[0].scrollIntoView();
        } else {
          $(_lSeqWidget.children().get(pIndex)).before(_lInst);
        }
        _renumber();
        pSequence.setSelectedInstruction(pInstruction);
        // add red badges and attach listener to the instruction
        addErrorBadgeToInstructionWidget(_lInst, pInstruction);
      },
      onInstructionRemoved: function(pIndex) {
        $(_lSeqWidget.children().get(pIndex)).remove();
        _renumber();
        // add hint text if the last instruction is removed
        if (pSequence.numberOfInstructions() == 0) {
          _lSeqWidget.append(lHintText);
        }
        pSequence.setSelectedInstruction(null);
      },
      onInstructionMoved: function(pFrom, pTo) {
        // UI has already been sorted manually
        if(pFrom == _lFrom && pTo == _lTo) {
          _lFrom = undefined;
          _lTo = undefined;
        } else {
          if(pTo == 0) {
            _lSeqWidget.prepend($(_lSeqWidget.children().get(pFrom)));
          } else if(pFrom > pTo){
            $(_lSeqWidget.children().get(pFrom)).insertAfter($(_lSeqWidget.children().get(pTo - 1)));
          } else {
            $(_lSeqWidget.children().get(pFrom)).insertAfter($(_lSeqWidget.children().get(pTo)));
          }
          _lSeqWidget.children().get(pTo).scrollIntoView();
        }
        _renumber();
      },
      onInstructionHighlighted: function(pInstruction) {
        if (!pInstruction) { return; }
        const lInstIndex = pSequence.getInstructionIndex(pInstruction);
        const lCard = $(_lSeqWidget.children().get(lInstIndex)).find('.ml_card');
        lCard.addClass('ml_card_erroneous');
      },
      onInstructionSelected: function(pInstruction, pErrorTarget, pOrigin) {
        _lSeqWidget.find('.ml_card_selected').removeClass('ml_card_selected');
        _lSeqWidget.find('.ml_card_erroneous').removeClass('ml_card_erroneous');
        if (pInstruction) {
          const lInstIndex = pSequence.getInstructionIndex(pInstruction);
          const lCard = $(_lSeqWidget.children().get(lInstIndex)).find('.ml_card');
          // Robot instructions are different, we will skip them for now
          if (!(pOrigin && pOrigin == 'instructionCard')) { if(lCard.get(0)) { lCard.get(0).scrollIntoView({ behavior: 'smooth' }); }}
          if (pErrorTarget != undefined) {
            lCard.addClass('ml_card_erroneous');
            lCard.find('.ml_parameter').find('h5').find('.ml_select_widget').find('select').removeClass('ml_card_erroneous');
            // Check if error was in a combined move instruction
            const lIndexedMatch = /^(\d).(.*)/.exec(pErrorTarget);
            if (lIndexedMatch != null) {
              if(['actuator', 'sequenceName'].includes(lIndexedMatch[2])) {
                const lTitle = widgets.camelCaseToText(lIndexedMatch[2]);
                lCard.find('.ml_parameter').find(`h5:contains("${lTitle}")`).eq(parseInt(lIndexedMatch[1]))
                  .parent().parent().find('.ml_select_widget').find('select').addClass('ml_card_erroneous'); // this code is to locate the select widget and
              }
              else {
                // NOTE: this catches at lest the if
                const lTitle = widgets.camelCaseToText(lIndexedMatch[2]);
                lCard.find('.ml_parameter').find(`h5:contains("${lTitle}")`).eq(parseInt(lIndexedMatch[1]))
                  .parent().parent().find('.ml_parameter_widget').addClass('ml_card_erroneous');
              }
            }
            else {
              // widget with text fields to highlight
              if (['expression', 'message'].includes(pErrorTarget)) {
                lCard.find('.ml_parameter').find(`h5:contains("${widgets.camelCaseToText(pErrorTarget)}")`)
                  .parent().parent().find('.ml_parameter_widget').addClass('ml_card_erroneous');
              } else if (pErrorTarget === 'fsm_add_new_state') {
                // fsm state widgets only have one add new state button
                lCard.find('.ml_fsm_add_new_state_button').addClass('ml_card_erroneous');
              }
              // widgets with select field to highlight
              else {
                lCard.find('.ml_parameter').find(`h5:contains("${widgets.camelCaseToText(pErrorTarget)}")`)
                  .parent().parent().find('.ml_select_widget').find('select').addClass('ml_card_erroneous');
              }
            }
          }
          else {
            // Apply warning outline if the instruction has an error. We will use the visibility of the badge to decide.
            const lBadge = $(_lSeqWidget.children().get(lInstIndex)).find('.ml_validator_badge_right');
            if(lBadge.first().css('visibility') == 'visible') { lCard.addClass('ml_card_erroneous'); }
            else { lCard.addClass('ml_card_selected'); }
          }
          pSequence.mInstructions.forEach(instruction => pInstruction !== instruction && instruction.reactSetWaypointSelectedIndex && instruction.reactSetWaypointSelectedIndex(-1));
        }
      },
      onNameChanged: function(pName) {
        _lSeqDoc.tab.setName(pName);
      },
    };
    const _translatePlaybackIndex = function (_pPbIndex) {
      // During playback, only non-muted instructions are deployed.
      // This function translates a deployed index, to its corresponding index in the UI and persisted data.
      let i; let _lPbIndex = 0;
      for (i = 0; i < pSequence.numberOfInstructions(); i++) {
        // Return the actual instruction index corresponding to _pPbIndex.
        if (_pPbIndex == _lPbIndex) { return i; }
        _lPbIndex++;
      }
      return -1;
    };
    let _lLastInstUpdated;
    const _lAppListener = {
      onStateChanged: function() {
        pApplication.isActive() ? _makeInstructionsNotEditable() : _makeInstructionsEditable();
      },
      onTrace: function(pData) {
        _lSeqWidget.find('.ml_animated_background').removeClass('running waiting paused');

        if(pData && pApplication.isActive()) {
          if(pData.sequences && pData.sequences.hasOwnProperty(pSequence.getName())) {
            const _lPlaybackIndex = parseInt(pData.sequences[pSequence.getName()]);
            const _lUIIndex = _translatePlaybackIndex(_lPlaybackIndex);
            let _lCurrentInstUI;
            let _lCurrentInstData;
            if(!isNaN(_lUIIndex) && _lUIIndex >= 0) {
              _lCurrentInstUI = $(_lSeqWidget.children().get(_lUIIndex));
              _lCurrentInstData = pSequence.getInstruction(_lUIIndex);
              if(_lCurrentInstData !== undefined ) {
                if(_lCurrentInstData.getCategory() == 'waitFor' && _lCurrentInstData.getName() != 'amountOfTime' && pData.state == 'running') {
                  _lCurrentInstUI.find('.ml_animated_background').addClass('waiting');
                } else {
                  _lCurrentInstUI.find('.ml_animated_background').addClass(pData.state);
                }
              }

              if(_lLastInstUpdated != _lUIIndex) {
                // See ticket VentionCo/vention_assembler#2897
                _lCurrentInstUI[0] && _lCurrentInstUI[0].scrollIntoView();
              }

              _lLastInstUpdated = _lUIIndex;
            }
          }
        }
      }
    };

    function _from(pEvent, pUi) {
      if(!pApplication.isActive()) {
        _lFrom = pUi.item.index();
      } else {
        // FIXME: sadly, this does not work, sended is null, and _lSeqWidget.sortable('cancel') does not work
        // $(pUi.sender).sortable('cancel');
      }
    }

    function _to(pEvent, pUi) {
      if(!pApplication.isActive()) {
        _lTo = pUi.item.index();
        pSequence.moveInstruction(_lFrom, _lTo);
      } else {
        // FIXME: sadly, this does not work, sended is null, and _lSeqWidget.sortable('cancel') does not work
        // $(pUi.sender).sortable('cancel');
      }
    }

    const _lSeqWidget = $('<div>').sortable({
      axis: 'y',
      distance: 4,
      tolerance: 'pointer',
      containment: '.sequence_editor_document',
      start: _from,
      update: _to,
      cancel: '.ignore_sortable_on_sequence_widget, input, textarea, button, select, option' // ignore the sortable on these elements
    });

    const lHintText = $('<div>').css({ height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', opacity: "0.7" })
      .append($('<div>').text('Click "Add Command" button below to add logic to your program'));

    //display hint message or list of instructions based on the number of instructions present
    if (pSequence.numberOfInstructions() == 0) {
      _lSeqWidget.append(lHintText);
    } else {
      for(let i = 0; i < pSequence.numberOfInstructions(); ++i) {
        const lInstruction = pSequence.getInstruction(i);
        const lInstructionCard = instructions.create(pLibrary, pApplication, pSequence, lInstruction);

        if (lInstructionCard === undefined) {
          // Note: (B.Richard) we may not always be able to create an instruction card
          // (ex. Path Following MachineApp 'path' instruction does not produce a card)
          continue;
        }
        lInstructionCard.on('click', function () { pSequence.setSelectedInstruction(lInstruction, undefined, 'instructionCard' ); });
        _lSeqWidget.append(lInstructionCard);

        // add red badges and attach listener to the instruction
        addErrorBadgeToInstructionWidget(lInstructionCard, lInstruction);
      }
      // triggers the Error Badges in the widgets on the right pane
      const lValidator = pLibrary.getValidator();
      if(lValidator.mNotFlattenCache[pApplication.getName()]) {
        pApplication.notify('onValidatorResult', lValidator.mNotFlattenCache[pApplication.getName()]);
        const lErrors = lValidator._flattenWarnings(lValidator.mNotFlattenCache[pApplication.getName()]);
        lErrors.forEach(function(pEl) {
          if (pEl.type === validatorErrorTypes.InstructionError) {
            pEl.instruction.notify('onInstructionErrorStatusUpdate', true);
          }
        });
      }
    }

    _renumber();

    if (lMachineAppSequenceIsReadonly) {
      _readOnly();
    }

    pSequence.addListener(_lSeqListener);
    pApplication.addListener(_lAppListener);

    _lSeqWidget.on('remove', function(pEvent) {
      pSequence.removeListener(_lSeqListener);
      pApplication.removeListener(_lAppListener);
    });

    if (pApplication.isActive()) {
      _makeInstructionsNotEditable();
    }

    const _lSeqDoc = new view_widgets.Document(pSequence, _lSeqWidget, []);

    return _lSeqDoc;
  }

  // This does the UI, adding a red error badge on the right of an instruction card
  function addErrorBadgeToInstructionWidget(pWidget, pInstruction) {
    const lErrorBadge = $('<span class="ml_validator_badge_right">')
      .append($('<span class="fas fa-exclamation">').css({'color': 'white', 'font-size': '10px'})
      );

    // attach a listener to each instruction to easily toggle the badge via the instruction, add only once
    // to prevent accumulation of listeners (we cant use removeListener)
    const lListener = {
      onInstructionErrorStatusUpdate: function(pOnOff) {
        pWidget.find('.ml_validator_badge_right').css('visibility', pOnOff ? 'visible' : 'hidden');
        if(pOnOff == false) {
          // We need to remove the error outline from the instruction
          const lCard = pWidget.find('.ml_card').first();
          if(lCard.hasClass('ml_card_erroneous')) {
            lCard.removeClass('ml_card_erroneous');
            lCard.addClass('ml_card_selected');
          }
        }
      }
    };

    // NOTE: this is needed for the CAD, as the it rebuild the application document when we switching from another tab,
    // but the instruction object is kept, to prevent an accumulation of older listener, we will replace it.
    const lListenerIndex = pInstruction.mListeners.findIndex(function(pEl) { return Object.keys(pEl).includes('onInstructionErrorStatusUpdate'); });
    if(lListenerIndex > -1) { pInstruction.mListeners[lListenerIndex] = lListener; }
    else { pInstruction.addListener(lListener); }

    function addInstructionErrorPopUPCard() {
      function detectClickOutside(pEl) {
        if(lErrorBadge.hasClass('ml_validator_popup')) { return; }

        const cb = function(pEvent) {
          // do nothing if we clicked on the container or on the badge
          if ($(pEvent.target).hasClass('ml_validator_popup')) { return; }
          if ($(pEvent.target).closest('.ml_validator_popup_card').length) { return; }
          $('.ml_validator_popup_card').remove();
          lErrorBadge.removeClass('ml_validator_popup');
          removeClickListener();
        };

        const removeClickListener = () => { document.removeEventListener('mousedown', cb); };

        // make sure we dont continuously stack up event listeners
        document.removeEventListener('mousedown', cb);
        document.addEventListener('mousedown', cb);
      }

      function buildErrorPopUpCard(pError) {
        const lWidget = $('<div>').css({position: 'relative'});
        const lCard = $('<div class="ml_validator_error_card">').css({
          padding: '0px',
          border: 'none',
          margin: '15px'
        });

        const lOptions = $('<div id="options">').css({display: 'flex', gap: '10px', flexDirection: 'column'});
        const lCloseButton = $('<button class="ml_close">')
          .css({
            position: 'absolute',
            top: '-15px',
            right: '0px',
          })
          .on('click', function() {
            $('.ml_validator_popup_card').remove();
          });

        pError?.onError?.options?.forEach((pOption, pIndex, pOptions) => {
          $('<div>')
            .css({
              backgroundColor: '#eff2f7',
              padding: '10px 5px',
              borderRadius: '5px',
            })
            .append(
              $('<span>')
                .text(pOption.message)
                .css({ margin: '5px' })
            )
            .appendTo(lOptions);
        });

        lWidget.append(
          lCloseButton,
          lCard.append(
            $('<div id="title">').text(pError.header),
            $('<div id="subtitle">').text(pError.onError.message),
            $('<div id="suggestions">').text('Ways to fix warning:'),
            lOptions
          )
        );

        return lWidget;
      }

      const lApplication = pInstruction.mApp;
      const lAllErrors = lApplication.mLibrary.mValidator.getAllWarningsForAppFromCache(lApplication.getName());
      const lError = lAllErrors.find(function (pWarning) { return pWarning.instruction == pInstruction; });

      const pos = lErrorBadge.position();

      $('.ml_validator_popup_card').remove();

      const container = $('<div class="ml_validator_popup_card">').css({
        'border': 'solid 1px #CBCFD6',
        'width': '312px',
        'background': 'white',
        'border-radius': '5px',
        'box-shadow': '0px 0px 30px 0px #999',
        'position': 'absolute',
        'top': pos.top + 15,
        'left': pos.left - 317,
        'z-index' : 1000,
      }).click(function(event) { event.stopPropagation(); }); // we need to prevent the instruction widget to catch the click to, otherwise it will deselect the erroneous field

      container.append(buildErrorPopUpCard(lError));

      pWidget.append(container);

      detectClickOutside(container);

      lErrorBadge.addClass('ml_validator_popup');
    }

    lErrorBadge.click(addInstructionErrorPopUPCard);
    lErrorBadge.mouseenter(addInstructionErrorPopUPCard);

    pWidget.append( lErrorBadge );
  }

  function addKeyframesToInstruction(selectedClip, instructionTreeElement) {
    const keyframes = (selectedClip?.keyframes || []);
    for (let i = 0; i < keyframes.length; i++) {
      const keyframe = keyframes[i];
      instructionTreeElement.addChild(keyframe.id, $(`<div>${helpers.getKeyframeName(keyframe, i)}</div>`), i);
    }
  }

  function getInstructionElement(instruction, instructionIconElement = null, instructionNameElement = null) {
    const instructionDisplay = instructionLabels.getInstructionDisplay(instruction);
    instructionIconElement = instructionIconElement ? instructionIconElement : $('<i>').addClass(instructionDisplay.icon);
    instructionNameElement = instructionNameElement ? instructionNameElement : $('<span>').addClass('ml_tree_document').text(instructionDisplay.name).css('text-transform', 'capitalize');

    return $(`<div data-clip-id="${instruction.getParameter("clipId")}">`)
      .append(instructionIconElement)
      .append(instructionNameElement)
      .css({paddingLeft: "5px"});
  }

  function applicationTreeWidget(pLibrary, pApplication, pOnCopySequence, pUser, pSingleAppMode) {
    let _lAppTree;
    let _lVariablesTree;
    let _lRobotAssetsTree;
    let _lSequenceListTree;
    let _lMainSequenceTree;
    let _lAppName;
    const _lSequences = [];
    let _lAppDocument;
    const _lCheckIfAppIsRunning = function() {
      if (pLibrary.getCurrentApplication() && pLibrary.getCurrentApplication() != pApplication && pLibrary.getCurrentApplication().isActive()){
        widgets.messageBox('Cannot perform action when another application is running', 'warning');
        return true;
      }

      return false;
    };
    const _addSequence = function(pSequence, pIndex) {
      const _lSeqWidget = $('<div class="ml_sequence h_layout"/>');
      const _lError = $('<div class="ml_error_icon ' + icons.error + '"/>');
      const _lIsChildSequence = pIndex > 0;
      const _lIcon = $('<div class="ml_tree_icon ' + (_lIsChildSequence ? icons.childSequence :  icons.sequence) + '"/>');
      let _lSeqName;
      let _lSeqDocument;
      const _lOpenSequence = function() {
        _lSeqDocument = sequenceDocument(pLibrary, pApplication, pSequence);
        $('.ml_editor').trigger('open_document', _lSeqDocument);
      };
      const _lSequenceTree = widgets.treeView(_lSeqWidget, true, true, true).addClass("sequence_list_container");
      const _addInstruction = function(pInstruction, pIndex) {
        let _lInstructionDisplay = instructionLabels.getInstructionDisplay(pInstruction);
        const _lInstructionNameElement = $('<span>').addClass('ml_tree_document').text(_lInstructionDisplay.name).css('text-transform', 'capitalize');
        const _lInstructionIconElement = $('<i>').addClass(_lInstructionDisplay.icon);

        // FIXME: only robot instruction should be treeView, when regular instruction are set as treeView:
        //.FIXME:     - the tree lines are broken
        // FIXME:     - the error-handling error badges are not aligned properly
        // FIXME: this is a temporary workaround to have it look good on the pendant
        const _lInstructionElement = widgets.treeView(getInstructionElement(pInstruction, _lInstructionIconElement, _lInstructionNameElement), true, false, true);

        const removeAnimatedBackgroundFromKeyframeElement = (keyframeId) => {
          const keyframeElement = _lInstructionElement.find(`#${keyframeId}`).find('div');
          keyframeElement.removeClass('ml_animated_background_tree running');
        };
        const addAnimatedBackgroundToKeyframeElement = (keyframeId) => {
          const keyframeElement = _lInstructionElement.find(`#${keyframeId}`).find('div');
          keyframeElement.addClass('ml_animated_background_tree running');
        };

        const _lInstructionListener = {
          onNameChanged: function(pName) {
            _lInstructionIconElement.removeClass(_lInstructionDisplay.icon);
            _lInstructionDisplay = instructionLabels.getInstructionDisplay(pInstruction);
            _lInstructionIconElement.addClass(_lInstructionDisplay.icon);
            _lInstructionNameElement.text(_lInstructionDisplay.name);
          },
          onClipChanged: (clip) => {
            _lInstructionNameElement.text(clip.name);
            _lInstructionElement.removeAllChild();
            addKeyframesToInstruction(clip, _lInstructionElement);
          },
          onRobotSimulationStateChange: (robotSimulationState) => {
            if (robotSimulationState.state === "running") {
              addAnimatedBackgroundToKeyframeElement(robotSimulationState.keyframeId);
            } else if (robotSimulationState.state === "completed") {
              removeAnimatedBackgroundFromKeyframeElement(robotSimulationState.keyframeId);
            }
          },
          onRobotSimulationInstructionCompleted: (keyframes) => {
            keyframes.forEach(keyframe => {
              removeAnimatedBackgroundFromKeyframeElement(keyframe.id);
            });
          },
          onRobotSimulationInstructionError: (keyframes) => {
            keyframes.forEach(keyframe => {
              removeAnimatedBackgroundFromKeyframeElement(keyframe.id);
            });
          },
        };
        _lInstructionElement.click(function(pEvent) {
          pEvent.stopPropagation();
          if (_lCheckIfAppIsRunning()) { return; }

          if(pApplication.isReadOnly()) {
            $('.ml_editor').trigger('open_document', readOnlyDocument());
            pEvent.stopPropagation();
            pEvent.preventDefault();
            pLibrary.selectApplication(pApplication);
            return;
          }

          pLibrary.selectApplication(pApplication);
          pApplication.selectSequenceByName(pSequence.getName());
          pSequence.setSelectedInstruction(pInstruction);

          if (pInstruction.getCategory() === 'robot' || pInstruction.getCategory() === 'robotLoop') {
            pLibrary.m3DContext?.robotAppsService.send('MachineLogic/treeView/instructionElement/INSTRUCTION_CLICKED', { instruction: pInstruction });
          }

          if (!_lSeqDocument) { return; }

          const _lInstructionIndex = pSequence.getInstructionIndex(pInstruction);
          const _lInstructionElement = _lSeqDocument.widget.children().eq(_lInstructionIndex);

          if (_lInstructionElement.length > 0) { // Scroll to the selected instruction
            _lInstructionElement.get(0).scrollIntoView({ behavior: 'smooth' });
          }
        });

        // FIXME: we will comment this for now as it break the CAD with robot instruction as they use treeView.
        // cad specific styling
        // if (environment.isOnCad()) { _lInstructionElement.css({display: 'flex', padding: '2px 3px'}); }

        const instructionClip = helpers.getClipById(pSequence, pInstruction.getParameter('clipId'));
        addKeyframesToInstruction(instructionClip, _lInstructionElement);

        _lSequenceTree.addChild(null, _lInstructionElement, pIndex, true);
        pInstruction.addListener(_lInstructionListener);
      };
      const _lSeqListener = {
        onNameChanged : function(pName) {
          _lSeqName.setValue(pName);
          _lSeqName.attr('title', pName);
        },
        onInstructionAdded : function(pInstruction, pIndex) {
          // Add the instruction at pSequence.mInstructions.length - 1 to append to the list below the last instruction
          _addInstruction(pInstruction, pIndex !== undefined ? pIndex : pSequence.mInstructions.length - 1);
        },
        onInstructionChanged: (instruction, instructionIndexInSequence) => {
          _lSequenceTree.removeChild(instructionIndexInSequence);
          _addInstruction(instruction, instructionIndexInSequence);
        },
        onInstructionRemoved: function(pIndex) {
          _lSequenceTree.removeChild(pIndex);
        },
        onInstructionMoved: function(pFrom, pTo) {
          _lSequenceTree.moveChild(pFrom, pTo);
        },
        onInstructionSelected: function (pInstruction) {
          _lSequenceTree.find('ul').find('.selected').removeClass( 'selected' );
          if (pInstruction) {
            // Remove Highlight from Sequence
            _lSequenceTree.find('.ml_sequence').removeClass( 'selected' );
            // Highlight selected instruction
            const lInstIndex = pSequence.getInstructionIndex(pInstruction);
            const lSelectElement = _lSequenceTree.find('ul').children().eq(lInstIndex);
            if (environment.isOnPendant()) {
              const lSelectDivOffset = lSelectElement.find('div').offset();
              const lMlAppListOffset = $('.ml_app_list').offset();

              // There were errors on the CI where .offset() would return undefined, and .top would cause a crash
              // This probably happens when the element cannot be found, sounds like a race condition?
              if (lSelectDivOffset !== undefined && lMlAppListOffset !== undefined) {
                const lOffset = lSelectDivOffset.top - lMlAppListOffset.top;
                if (lOffset < 0 || lOffset > 450) {
                  // Note (aj) the offset is the absolute position of the selected element on the screen, and we would scroll the element
                  // only if it is off the screen, making the experience less annoying when clicking instructions in the right pane.
                  lSelectElement[0].scrollIntoView({ behavior: 'smooth', block: "nearest" });
                }
              }
            }
            lSelectElement.find('.ml_tree_view').children().first().addClass('selected');
          }
          else {
            _lSequenceTree.find('.ml_sequence').addClass( 'selected' );
          }
        }
      };

      _lSeqWidget.contextmenu(function(pEvent) {
        // Locked sequences dont have this menu
        const lSequenceLocked = pSequence.getIsLocked();
        const lCannotDelete = pSequence.isInitialSequence() || lSequenceLocked;

        pEvent.preventDefault();
        pEvent.stopPropagation();

        const _lDisabledOption = pApplication.isReadOnly();

        const _lMenu = widgets.contextMenu();
        const _lCopyField = $('<div>').append($('<i>').addClass('icon-copy')).append($('<span>').text('Copy Sequence'));
        const _lRenameField = $('<div>').append($('<i>').addClass('icon-edit')).append($('<span>').text('Rename Sequence'));
        const _lDeleteField = $('<div>').css('color', lCannotDelete ? '#A0A0A0' : '#C70000').append($('<i>').addClass('icon-delete')).append($('<span>').text('Delete Sequence'));

        const lIsCopyDisabled = (pSequence.isInitialSequence() && pApplication.mIsMachineApp === true) || lSequenceLocked;

        _lMenu.addItem(_lCopyField, function() {
          pOnCopySequence(pSequence);
        }, { disabled: _lDisabledOption }).addClass(lIsCopyDisabled ? 'ml_context_menu_item_disabled machine_app_locked_sequence' : '');

        _lMenu.addItem(_lRenameField, function() {
          _lSeqName.enable();
          _lSeqName.getInput().select();
        }, { disabled: _lDisabledOption }).addClass(lIsCopyDisabled ? 'ml_context_menu_item_disabled machine_app_locked_sequence' : '');

        _lMenu.addItem(); // Separator
        _lMenu.addItem(_lDeleteField, function() {
          const lNumberOfInstructionsEffected = pApplication.mLibrary.getValidator().instructionsUsingSequence(pSequence.getName(), pApplication).length;
          if (lNumberOfInstructionsEffected == 0) { pApplication.removeSequence(pSequence.getName()); }
          else {
            widgets.showConfirmationModal('Delete Child Sequence', `This action will result in ${lNumberOfInstructionsEffected} invalid MachineLogic command${lNumberOfInstructionsEffected > 1 ? 's' : ''}.`,
              function() { pApplication.removeSequence(pSequence.getName()); });
          }
        }, { disabled: _lDisabledOption }).addClass(pIndex === 0 ? 'ml_context_menu_item_disabled' : '').addClass( lCannotDelete ? 'ml_context_menu_item_disabled machine_app_locked_sequence' : '');

        _lMenu.show(pEvent.pageX + 10, pEvent.pageY - 5);
        _lMenu.css({ 'z-index': $('#pane_machine_logic').css('z-index') });
      });

      if(pSequence) {
        _lSeqName = widgets.autoResizeTextInput(pSequence.getName()).addClass('ml_tree_document').attr('title', pSequence.getName()).disable();

        _lSeqWidget.on('document_opened', function(pEvent, pObject) {
          if(pObject.object != pSequence) { _lSeqWidget.removeClass('selected'); }
        });

        _lSeqWidget.click(function(pEvent) {
          if (_lCheckIfAppIsRunning()) {return;}

          if(pApplication.isReadOnly()) {
            pEvent.stopPropagation();
            pEvent.preventDefault();
            $('.ml_editor').trigger('open_document', readOnlyDocument());
            pLibrary.selectApplication(pApplication);
            return;
          }

          pLibrary.selectApplication(pApplication);
          pApplication.selectSequenceByName(pSequence.getName());
          pSequence.setSelectedInstruction(null);

          _lSeqWidget.addClass('selected');
        });
        _lSeqName.getInput().on('change', function() { if (_lSeqName.getValue() && _lSeqName.getValue().trim().length > 0) { pSequence.setName(_lSeqName.getValue()); } else { _lSeqName.setValue(pSequence.getName()); } });
        _lSeqName.getInput().keypress(function(pEvent) { if(pEvent.which == 13 || pEvent.which == 27) { _lSeqName.disable(); } });  // Enter or Esc
        _lSeqName.getInput().blur(function() { _lSeqName.disable(); });

        pSequence.addListener(_lSeqListener);
        _lSeqWidget.on("remove", () => pSequence.removeListener(_lSeqListener));

        // Add the instructions to the tree
        pSequence.mInstructions.forEach(_addInstruction);

        if (pIndex === 0) {
          _lMainSequenceTree = _lSequenceTree;
          _lMainSequenceTree.onExpand = function() {
            _lSequences.forEach(function(pSequence, pIndex) {
              if (pIndex === 0) {
                return;
              }
              pSequence.widget.show();
            });
          };

          _lMainSequenceTree.onCollapse = function() {
            _lSequences.forEach(function(pSequence, pIndex) {
              if (pIndex === 0) {
                return;
              }
              pSequence.widget.hide();
            });
          };

          _lMainSequenceTree.shouldDisplayCaret = function() {
            return _lSequences.length > 1;
          };
        }

        _lSeqWidget.append(_lError, _lIcon, _lSeqName);

        if(pSequence.getIsLocked()) {
          _lSeqWidget.append($('<div>').addClass('icon-lock').css('padding-right', '0.5rem'));
        }

        _lSequences.push({
          sequence : pSequence,
          tree: _lSequenceTree,
          widget : _lSequenceListTree.addChild(null, _lSequenceTree, pIndex).addClass('h_layout'),
          openDocument : _lOpenSequence
        });
      }

      function setSortableSequences(_lSequenceTree) {
        let _lStartIndex = -1;
        let _lStartSequence;
        const lGetSequenceFromNode = function (pNode) {
          const _lSequence = _lSequences.find(function (pSequence) {
            return pSequence.widget.get(0).isSameNode(pNode); // Check the refs to the list element
          });

          return _lSequence ? _lSequence.sequence : undefined;
        };

        _lSequenceTree.find('> ul').addClass("instruction_sortable").sortable({
          delay: 150,
          axis: "y",
          tolerance: "pointer",
          connectWith: ".instruction_sortable",
          start: function (pEvent, pUi) {
            pUi.placeholder.append(pUi.item.html()).css("visibility", "visible");     // Copy the item into the placeholder and show it
            pUi.placeholder.find("> div").css("color", "transparent");                // Hide the content of the placeholder so that height is maintained
            pUi.item.find("> span").css("visibility", "hidden");
            _lStartIndex = pUi.item.index();
            _lStartSequence = lGetSequenceFromNode(pUi.item.parent().parent().parent().get(0));
          },
          stop: function (pEvent, pUi) {
            const _lEndSequenceTreeNode = pUi.item.parent().parent().parent();
            const _lEndIndex = pUi.item.index();
            const _lEndSequence = lGetSequenceFromNode(_lEndSequenceTreeNode.get(0));

            pUi.item.find("> span").css("visibility", "visible");

            if (!_lSequenceListTree.get(0).isSameNode(_lEndSequenceTreeNode.parent().parent().get(0))) {
              // Note (mkosarek), We've dragged to a different app tree, let's not do this
              $(this).sortable("cancel");
              widgets.messageBox("Cannot move an instruction between applications.", "warning");
              return;
            }

            if (_lStartSequence === undefined) {
              console.error("Unable to move the instruction from its start sequence");
              return;
            } else if (_lEndSequence === undefined) {
              console.error("Unable to move the instruction to its end sequence");
              return;
            }

            // Note: Cancel the event to allow the Sequence Listener to handle the visual reordering
            $(this).sortable("cancel");
            if (_lStartSequence === _lEndSequence) {
              _lStartSequence.moveInstruction(_lStartIndex, _lEndIndex);
            } else {
              const _lMovedInstruction = _lStartSequence.getInstruction(_lStartIndex);

              // Note: Validating that we can drop the instruction in this sequence
              switch (_lMovedInstruction.getCategory()) {
                case "trigger":
                case "loop": {
                  const _lMovedInstructionTriggerSequence = _lMovedInstruction.getParameter("sequenceName");
                  if (_lMovedInstructionTriggerSequence === _lEndSequence.getName()) {
                    $(this).sortable("cancel");
                    widgets.messageBox("Cannot move the instruction to this sequence because the instruction executes this sequence.", "warning");
                    return;
                  }
                  break;
                }
                case "condition": {
                  const _lConditionList = _lMovedInstruction.getParameter("conditions");
                  for (let _lConditionListIdx = 0; _lConditionListIdx < _lConditionList.length; _lConditionListIdx++) {
                    const _lConditionItem = _lConditionList[_lConditionListIdx];
                    if (_lConditionItem.sequenceName === _lEndSequence.getName()) {
                      $(this).sortable("cancel");
                      widgets.messageBox("Cannot move the instruction to this sequence because the instruction executes this sequence.", "warning");
                      return;
                    }
                  }
                  break;
                }
              }

              _lStartSequence.removeInstruction(_lStartIndex);
              if (_lMovedInstruction.getCategory() === "robot" && _lMovedInstruction.getName() === "simulate") {
                if (_lMovedInstruction.mSequence.robotParameters.clips.length > 0 && _lMovedInstruction.mSequence.robotParameters.clips.some(el => el.id === _lMovedInstruction.getParameter("clipId"))) {
                  pLibrary.getRobotAppsService().send('MachineLogic/RobotInstructionEditable/MovedToAnotherSequence', { movedInstruction: _lMovedInstruction, destinationSequence: _lEndSequence });
                }
              }
              _lEndSequence.addInstruction(_lMovedInstruction.toJson(), _lEndIndex);
            }
          },
        });
      }

      let makeSequenceSortable = true;
      if(pApplication.isReadOnly())                 { makeSequenceSortable = false; }
      else if(pApplication.mIsMachineApp === true)  { makeSequenceSortable = false; }

      if(makeSequenceSortable) {
        setSortableSequences(_lSequenceTree);
        if(pApplication.isActive()) {
          _lSequenceTree.find('.instruction_sortable').sortable('disable');
          if (isSortable(_lSequenceListTree)) {
            _lSequenceListTree.sortable('disable');
          }
        }
      }

      return _lSeqWidget;
    };
    const _lUpdateMainSequenceCaret = function() {
      if (_lSequences && _lSequences.length > 0) {
        _lSequences[0].tree.updateCaret();
      }
    };

    const _lApplicationListener = {
      onStateChanged : function(state) {
        if (pApplication.isReadOnly() || pApplication.mIsMachineApp === true) {
          return;
        }

        if (state === 'running') {
          $('.instruction_sortable').sortable('disable');
          if (isSortable(_lSequenceListTree)) {
            _lSequenceListTree.sortable('disable');
          }

          return;
        }

        if (state === 'completed') {
          $('.instruction_sortable').sortable('enable');
          if (isSortable(_lSequenceListTree)) {
            _lSequenceListTree.sortable('enable');
          }

          return;
        }
      },
      onNameChanged : function(pName) {
        _lAppName.setValue(pName); _lAppName.attr('title', pName);
      },
      onSequenceAdded : function(pSequence) {
        const _lAddedWidget = _addSequence(pSequence, pSequence.mApp.mSequences.length - 1);
        _lAddedWidget.get(0).scrollIntoView({ behavior: 'smooth' });
        _lAddedWidget.find('> .ml_tree_document').click(); // Click to open the sequence document
        _lUpdateMainSequenceCaret();
      },
      onSequenceRemoved: async function (pRemovedSequence) {
        const _lSequence = _lSequences.find(function (pSequence) { return pSequence.sequence == pRemovedSequence; });
        if (_lSequence) {
          _lSequence.widget.remove();
          _lSequences.splice(_lSequences.indexOf(_lSequence), 1);
        }
        _lUpdateMainSequenceCaret();
      },
      onSequenceMoved: function(pFrom, pTo) {
        const _lSequenceListTreeListElement = _lSequenceListTree.find('> ul');
        if(pTo == 0) {
          _lSequenceListTreeListElement.prepend($(_lSequenceListTreeListElement.children().get(pFrom)));
        } else if(pFrom > pTo){
          $(_lSequenceListTreeListElement.children().get(pFrom)).insertAfter($(_lSequenceListTreeListElement.children().get(pTo - 1)));
        } else {
          $(_lSequenceListTreeListElement.children().get(pFrom)).insertAfter($(_lSequenceListTreeListElement.children().get(pTo)));
        }
      },
      onSequenceSelected : function(pSequence) {
        if (pSequence == null) {
          return;
        }

        _lAppTree.find('.selected').removeClass('selected');

        if (environment.isOnAppPage()) {
          _lSequences.forEach(function(pSequenceTreeViewItem) {
            if (pSequenceTreeViewItem.sequence == pSequence) {
              if (pSequenceTreeViewItem.sequence.getSelectedInstruction() === null) {
                pSequenceTreeViewItem.widget.find('.ml_sequence').addClass('selected');
              }
              if(pApplication.isReadOnly()) {
                // NOTE: we should never reach here during normal flow, but will keep it in case
                console.warn('attempt to select a sequence in read only mode.');
                $('.ml_editor').trigger('open_document', readOnlyDocument());
                return;
              }
              pSequenceTreeViewItem.openDocument();
              pLibrary.getRobotAppsService().send('SEQUENCE_SELECTED');
            }
          });
        }
      },
      onTrace: function (pTraceData) {
        pApplication.listSequences().forEach(function(pSequenceName) {
          const _lSequence = _lSequences.find(function(pSequence) { return pSequence.sequence.mName == pSequenceName; });

          if (_lSequence === undefined) {
            return;
          }

          const _lSequenceTree = _lSequence.widget;
          const elementsWithAnimatedBackgroundTree = _lSequenceTree.find('.ml_animated_background_tree');
          // HACK: https://github.com/VentionCo/vention_ros/issues/569 this code removes the green animation bar for tree components when running, but we don't it to be removed for waypoints at this time.
          const elementsWithAnimatedBackgroundTreeWithoutRobotWaypoints = elementsWithAnimatedBackgroundTree.filter(index => !(pTraceData?.state === 'running' && /Waypoint \d+/.test(elementsWithAnimatedBackgroundTree[index].outerText)));
          elementsWithAnimatedBackgroundTreeWithoutRobotWaypoints.removeClass('ml_animated_background_tree running waiting paused completed');

          if (pTraceData && pTraceData.sequences.hasOwnProperty(pSequenceName)) {
            const _lInst = parseInt(pTraceData.sequences[pSequenceName]);
            if (!isNaN(_lInst) && pTraceData.state != 'completed') {
              const _lCurrentSequenceUI = _lSequenceTree.find('.ml_sequence');
              const _lCurrentInstUI = _lSequenceTree.find('ul').children().eq(_lInst).find('.ml_tree_view').children().first();
              const _lCurrentInstData = _lSequence.sequence.getInstruction(_lInst);
              if(_lCurrentInstData !== undefined ) {
                const isSequenceCollapsed = !_lSequence.tree.isExpanded();
                if(_lCurrentInstData.getCategory() == 'waitFor' && _lCurrentInstData.getName() != 'amountOfTime' && pTraceData.state == 'running') {
                  isSequenceCollapsed ? _lCurrentSequenceUI.addClass('ml_animated_background_tree waiting') : _lCurrentInstUI.addClass('ml_animated_background_tree waiting');
                } else {
                  isSequenceCollapsed ? _lCurrentSequenceUI.addClass('ml_animated_background_tree ' + pTraceData.state) : _lCurrentInstUI.addClass('ml_animated_background_tree ' + pTraceData.state);
                }
              }
              else {
                // No current instruction, the main sequence is waiting on some child or continuous move
                _lSequenceTree.find('ul').children().eq(_lInst - 1).find('div').addClass('ml_animated_background_tree waiting');
              }
            }
          }
        });
      },
      onValidatorResult : function(result) {
        pApplication.listSequences().forEach((pSeq) => {
          const _lSequence = _lSequences.find(function(pSequence) { return pSequence.sequence.mName == pSeq; });
          const _lSequenceTree = _lSequence.widget;

          // we will hide the instruction icon and show an error badge if there is an error
          // for simplicity we will always start from an non erroneous state
          _lSequenceTree.find('.ml_validator_badge_left').remove();
          _lSequenceTree.find('.ml_validator_hidden_icon').show();
          // FIXME: This is a race condition. When a sequence is added validation will be performed with some delay when we deploy, while the
          // SequenceDocument is rebuild right away, as SequenceDocument is using cached validator results, thus it won't have the new sequence in there.
          // Fortunately we can ignore this case as a proper validation will be done on deploy right after, and everything will be sync. In the future we
          // might want to perform per app validation when adding a sequence. For the moment Validator.validateApp is doing more that juste validating the
          // app (does some notifications as well).
          result[pSeq] && result[pSeq].forEach((pInst) => {
            if (pInst != null) {
              // only add once, instructions can have multiple errors
              if(_lSequenceTree.find('ul').children().eq(pInst.index).find('div').find('.ml_validator_badge_left').length) { return; }

              const lInstructionElement = _lSequenceTree.find('ul').children().eq(pInst.index).find('div').find('i').first();
              lInstructionElement.addClass('ml_validator_hidden_icon').hide();
              const lErrorBadge = $('<span class="ml_validator_badge_left">').append($('<span class="fas fa-exclamation">').css({'color': 'white', 'font-size': '6px'}));
              if(environment.isOnCad()) { lErrorBadge.css('top', '0px'); }
              lInstructionElement.after(lErrorBadge);
            }
          });
        });
      },
      onInstructionChanged: (clip) => {
        for (let i = 0; i < pApplication.mSequences.length; i++) {
          const sequence = pApplication.mSequences[i];
          for (const instruction of sequence.mInstructions) {
            const isInstructionPartOfClip = instruction.getParameter('clipId') === clip.id;
            if (isInstructionPartOfClip) {
              instruction.notify('onClipChanged', clip);
            }
          }
        }
      }
    };
    const _lLibraryListener = {
      onApplicationRemoved : function(pApp) {
        if(pApp === pApplication) {
          _lAppTree.parent().remove();
        }
        if (pLibrary.getCurrentApplication() === undefined) {
          $('.ml_editor').trigger('close_all_documents');
        }
      }
    };

    if(pApplication) {
      let lIsApplicationDownloadable = false;
      if (pUser?.isAdmin) { lIsApplicationDownloadable = true; }
      else { lIsApplicationDownloadable = pLibrary.isVersionDownloadable(); }

      // Application name
      _lAppName = widgets.autoResizeTextInput(pApplication.getName()).css({ 'font-weight': 'bold', 'width': '100%' }).addClass('ml_tree_document').attr('title', pApplication.getName()).disable();
      _lAppName.getInput().on('change', function() { if (_lAppName.getValue() && _lAppName.getValue().trim().length > 0) { pApplication.setName(_lAppName.getValue()); } else { _lAppName.setValue(pApplication.getName()); } });
      _lAppName.getInput().keypress(function(pEvent) { if(pEvent.which == 13 || pEvent.which == 27) { _lAppName.disable(); } });  // Enter or Esc
      _lAppName.getInput().blur(function() { _lAppName.disable(); });
      _lAppName.click(function(pEvent) {
        if (_lCheckIfAppIsRunning()) { return; }
        if(pApplication.isReadOnly() ) {
          $('.ml_editor').trigger('open_document', readOnlyDocument());
          pEvent.stopPropagation();
          pEvent.preventDefault();
          pLibrary.selectApplication(pApplication);
          return;
        }
        _lAppDocument = applicationDocument(pApplication);
        $('.ml_editor').trigger('open_document', _lAppDocument);
        // HACK: maybe not the best way to trigger the main sequence
        _lMainSequenceTree.find('span').click();
      });

      _lAppName.on('document_opened', function (pEvent, pDocument) {
        _lRobotAssetsTree && _lRobotAssetsTree.removeClass('selected');
        _lVariablesTree.removeClass('selected');
        if (pDocument.object == pApplication) {
          if (pDocument.name === 'Robot Assets') { _lRobotAssetsTree.addClass('selected'); }
          else if (pDocument.name === 'Variables & Functions') { _lVariablesTree.addClass('selected'); }
          pLibrary.selectApplication(pApplication);
          pApplication.selectSequenceByName(null);
        }
      });

      const readOnly = $('<div>').text('Read Only')
        .css({
          'color': '#D9534F', 'background-color': 'rgba(217, 83, 79, 0.1)',
          'border': '1px #D9534F solid', 'border-radius': '5px',
          'width': '135px',
          'padding': '0px 2px', 'margin': '2px',
        });
      // Main tree widget
      _lAppTree = widgets.treeView($('<div class="h_layout">').addClass('ml_application').append(
        $('<i>').addClass('icon-launch-sequence-editor').css('font-size', '15px'),
        _lAppName,
        pApplication.isReadOnly() ?  readOnly : null
      ), true, !pSingleAppMode);

      _lAppTree.prepend('<div class="ml_error_icon icon-help"/>');

      const lCreateTreeLabelElement = function(pLabel, pIcon, pOnClick) {
        const lIconElement = $('<i>').addClass(pIcon).css({fontSize: '14px'});
        const lContent = $('<div class="h_layout">').append($('<div class="ml_tree_document">')
          .text(pLabel)).prepend(lIconElement).css('font-weight', '500').css('font-size', '0.9rem').css('font-weight', 'bold').click(pOnClick);
        const lRetval = widgets.treeView(lContent, true, false, false);

        return lRetval;
      };

      const robotConfigs = pLibrary.getConfigManager().listRobots();
      const shouldShowRobotAssetsTab = () => {
        const robotParameters = pApplication.robotParameters;

        return environment.isOnCad()
          ? robotConfigs?.length > 0
          : robotConfigs?.length > 0 &&
              robotParameters &&
              (robotParameters.clips?.length > 0 ||
                robotParameters.arrays?.length > 0 ||
                robotParameters.calibrationParts?.length > 0);
      };

      const hideRobotAssetsTab = () => {
        const elements = document.querySelectorAll(".ml_tree_document");
        for (let i = 0; i < elements.length; i++) {
          const element = elements[i];
          if (element.textContent === "Robot Assets") {
            element.closest("li").remove();
            break;
          }
        }
      };

      if (environment.isOnCad()) {
        pLibrary.m3DContext.registerForNotification('robot_removed', hideRobotAssetsTab);
      }

      if (shouldShowRobotAssetsTab()) {
        _lRobotAssetsTree = lCreateTreeLabelElement('Robot Assets', 'icon-robot-assets', function () {
          if (pLibrary.getCurrentApplication() && pLibrary.getCurrentApplication().isActive()) {
            widgets.messageBox('Cannot edit Robot Assets while playing an application', 'warning');
            return;
          }
          pApplication.selectSequenceByName(null);
          _lAppDocument = robotApplicationDocument(pLibrary, pApplication, {
            robotConfigs,
            ...(environment.isOnCad() && { p3DContext: pLibrary.m3DContext })
          }, function (pTabIndex) {
            gLastRobotAssetTabActive = pTabIndex;
          });
          _lAppDocument.name = 'Robot Assets'; // The document.name is used to distinguish from the Variables & Functions document which also passes the application object
          $('.ml_editor').trigger('open_document', _lAppDocument);
          _lAppDocument.widget.find('ul').children().eq(gLastRobotAssetTabActive).click();
        }).css({ paddingLeft: '5px', width: '98%' });
        _lAppTree.addChild(null, (_lRobotAssetsTree), 1);
      }
      _lVariablesTree = lCreateTreeLabelElement('Variables & Functions', 'icon-variable', function () {
        if (_lCheckIfAppIsRunning()) { return; }
        if(pApplication.isReadOnly()) { pLibrary.selectApplication(pApplication); }
        else { pApplication.selectSequenceByName(null); }
        _lAppDocument = applicationDocument(pApplication);
        _lAppDocument.name = 'Variables & Functions'; // The document.name is used to distinguish from the Robot Assets Document which also passes the application object
        $('.ml_editor').trigger('open_document', _lAppDocument);
      }).css({ paddingLeft: '5px', width: '98%' });
      _lAppTree.addChild(null, (_lVariablesTree), 2);
      _lSequenceListTree = lCreateTreeLabelElement('Sequences', 'icon-sequence', function(pEvent) {
        if (_lCheckIfAppIsRunning()) {return;}
        if(pApplication.isReadOnly()) {
          $('.ml_editor').trigger('open_document', readOnlyDocument());
          pEvent.stopPropagation();
          pEvent.preventDefault();
          pLibrary.selectApplication(pApplication);
          return;
        }

        const _lSeqDocument = sequenceDocument(pLibrary, pApplication, pApplication.getInitialSequence());
        pApplication.getInitialSequence().setSelectedInstruction(null);
        pLibrary.m3DContext?.robotAppsService.send('SEQUENCE_SELECTED');
        $('.ml_editor').trigger('open_document', _lSeqDocument);
        _lMainSequenceTree.find('span').click();
      }).css({paddingLeft: '5px', width: '98%'}).addClass('ml_sequences_tree');

      if (!window._main || !window._main.ifTouchScreen || !window._main.ifTouchScreen()) {
        if(!pApplication.isReadOnly()) {
          _lSequenceListTree.sortable({
            delay: 150,
            axis: 'y',
            tolerance: 'pointer',
            items: '> ul > li:not(:first-child)',
            start: function(pEvent, pUi) {
              $(pUi.item).data('startIndex', pUi.item.index());
            },
            stop: function(pEvent, pUi) {
              // Note: Cancel the event to allow the Sequence Listener to handle the visual reordering
              const lNewIndex = pUi.item.index();
              $(this).sortable('cancel');
              pApplication.moveSequence(pUi.item.data('startIndex'), lNewIndex);
            }
          });
        }
      }

      _lAppTree.addChild(null, (_lSequenceListTree),  3);

      // Sequences
      // If this is the main sequence, we add the child sequences to the tree as well.
      pApplication.listSequences().forEach(function(pSequenceName, pIndex) {
        _addSequence(pApplication.getSequence(pSequenceName), pIndex);
      });

      pApplication.addListener(_lApplicationListener);
      pLibrary.addListener(_lLibraryListener);

      // Trigger the first click to open the first sequence. The setTimeout is needed to accommodate the React/jQuery link.
      setTimeout(() => _lAppName.click(), 0);
    }

    // Clean listener when DOM element is removed
    _lAppTree.on('remove', function onRemoveAppTree() {
      if (undefined !== pApplication) {
        pApplication.removeListener(_lApplicationListener);
        pLibrary.removeListener(_lLibraryListener);
      }
    });

    const lWrapper = $('<li>').append(_lAppTree);

    lWrapper.highlightVariable = function(pVariableName) {
      _lAppDocument = applicationDocument(pApplication);
      $('.ml_editor').trigger('open_document', _lAppDocument);

      // find the variable name id
      const lVariableKey = Object.values(pApplication.mParameters.mParameters).find(function(pEl) { return pVariableName == pEl.name; });
      const lSelectWidget = _lAppDocument.appParamCards[lVariableKey.id].find('.ml_parameter').find(`h5:contains("Input to track")`)
        .parent().parent().find('.ml_select_widget').find('select');
      lSelectWidget.addClass('ml_card_erroneous');
    };

    return lWrapper;
  }

  function uiEditordocument(pLibrary, pApplication) {
    const _lUIViewerContainer = $('<div>').css('height', '100%');
    const _lAppDoc = new view_widgets.Document(pApplication.getUi(), _lUIViewerContainer, []);
    let _lViewMode = 'play';
    let _lApplicationListener;
    if (!pApplication.isActive() && pApplication.getUi().isEmpty() && !pApplication.getUi().isReadonly()) {
      _lViewMode = 'edit';
    }

    const _lUpdate = function() {
      _lUIViewerContainer.empty();
      let _lRenderedView = undefined;
      if (_lViewMode === 'play') {
        // Select the application so that the player works properly
        const _lPlayerWidget = view_widgets.playerWidget(pLibrary, isRobotReadyWithoutEnvironment(environment));

        pLibrary.selectApplication(pApplication);

        _lApplicationListener = {};
        pApplication.addListener(_lApplicationListener);
        _lRenderedView = uiBuilder.renderUiPlay(pLibrary, pApplication, pApplication.getUi(), _lPlayerWidget, {
          setRuntimeConfig: _lPlayerWidget.setRunTimeConfiguration,
          setTraceCallback: function(pOnTrace) {
            _lApplicationListener.onTrace = pOnTrace;
          },
          setStateChangedCallback: function(pOnStateChanged) {
            _lApplicationListener.onStateChanged = pOnStateChanged;
          }
        });

        _lRenderedView.on('remove', () => pApplication.removeListener(_lApplicationListener));
      }
      else if (_lViewMode === 'edit') {
        if (_lApplicationListener) {
          pApplication.removeListener(_lApplicationListener);
          _lApplicationListener = undefined;
        }

        _lRenderedView = uiBuilder.renderUiEdit(pLibrary, pApplication, pApplication.getUi());
      }
      else {
        console.error('Unknown view mode: ', _lViewMode);
        return;
      }

      // TODO: Make the toggle button smoothly transition again, but idc for now
      _lUIViewerContainer.append(_lRenderedView);
      const lHeaderArea = _lRenderedView.find('.ml_ui_builder_header');
      if (!pApplication.getUi().isReadonly()) {
        const lModeToggleButton = $('<div>').addClass('ml_ui_builder_mode_toggle ' + (_lViewMode == 'play' ? 'play_mode' : 'edit_mode'))
          .append($('<span>').text('Play Mode'))
          .append($('<span>').text('Edit Mode'))
          .append($('<span>').addClass('ml_ui_builder_mode_slider'))
          .on('click', function() {
            if (_lViewMode === 'play' ) {
              if (pApplication.isActive()) {
                widgets.messageBox('Application is running', 'error');
                return;
              } else {
                lModeToggleButton.removeClass('play_mode').addClass('edit_mode');
                _lViewMode = 'edit';
              }
            } else {
              lModeToggleButton.addClass('play_mode').removeClass('edit_mode');
              _lViewMode = 'play';
            }
            _lUpdate();
          });

        lHeaderArea.append(lModeToggleButton);
      }
    };

    _lUpdate();

    _lUIViewerContainer.on('remove', function() {
      if (_lApplicationListener) {
        pApplication.removeListener(_lApplicationListener);
      }
    });

    return _lAppDoc;
  }

  function uiTreeWidget(pLibrary, pApplication, pUibuilerProps) {
    const lOpenOperatorUi = function(pEvent) {
      if (!pLibrary.canSelectApplication(pApplication)) {
        widgets.messageBox('Cannot perform action when another application is running', 'warning');
        return;
      }

      pEvent?.stopPropagation();
      lAppListItem.parent().find('.selected').removeClass('selected');
      lUILabel.addClass('selected');

      $('.ml_editor').trigger('open_document', uiEditordocument(pLibrary, pApplication));
    };

    const lAppListItem = $('<li>').addClass('ml_ui_tree_widget_item');
    const lAppLabel = $('<div>')
      .addClass('ml_ui_tree_widget_item_app')
      .append(
        $('<i>').addClass('icon-launch-sequence-editor'),
        $('<span>').addClass('label-launch-sequence-editor').text(pApplication.getName()),
      )
      .on('click', lOpenOperatorUi)
      .attr('title', pApplication.getName());

    let lHasOperatorUi = pApplication.getUi().isEmpty();
    const lUIEmptyItem = $('<span>').text('(empty)').addClass('ml_ui_tree_widget_item_ui_empty');
    const lUILabel = $('<div>').addClass('ml_ui_tree_widget_item_ui').append(
      $('<i>').addClass(icons.uiBuilder),
      $('<span>').append(
        $('<span>').text('Operator Interface ').addClass('ml_ui_tree_widget_item_ui_label'),
        lUIEmptyItem
      )
    );

    lAppListItem.append(lAppLabel, lUILabel);

    if (!lHasOperatorUi) lUIEmptyItem.hide();

    lUILabel.on('click', lOpenOperatorUi);
    const lTreeViewListener = {
      onTrace: function (pTraceData) {
        lUILabel.removeClass('ml_animated_background_tree running waiting paused completed');
        if (!pTraceData) {
          return; // Note, this happens on a reset (2021-09-13 mkosarek)
        }

        if (pTraceData.state == 'completed') {
          return;
        }

        const lSequenceMap = pTraceData.sequences;
        lUILabel.addClass('ml_animated_background_tree');

        if (pTraceData.state === 'paused') {
          lUILabel.addClass('paused');
          return;
        }

        lUILabel.addClass(pTraceData.state);
        if (!lSequenceMap) return;

        for (const lSequenceName in lSequenceMap)  {
          const lInstructionIndex = Number(lSequenceMap[lSequenceName]);
          if (isNaN(lInstructionIndex)) continue;

          const lSequence = pApplication.getSequence(lSequenceName);
          if (!lSequence) continue;

          const lCurrentInstData = lSequence.getInstruction(lInstructionIndex);
          if (!lCurrentInstData) continue;

          if(lCurrentInstData.getCategory() == 'waitFor' && lCurrentInstData.getName() != 'amountOfTime' && pTraceData.state == 'running') {
            lUILabel.addClass('waiting');
            break;
          }
        }
      }
    };

    pApplication.addListener(lTreeViewListener);

    const lWidgetGroupListeners = {
      onWidgetAdded: function() {
        lUIEmptyItem.hide();
        lHasOperatorUi = false;
      },
      onWidgetRemoved: function () {
        if (!lHasOperatorUi && pApplication.getUi().isEmpty())  {
          lUIEmptyItem.show();
        }

        lHasOperatorUi = true;
      }
    };

    // Listeners to toggle tag that denotes if ui is empty.
    // For existing tabs
    pApplication.getUi().listTabs().forEach(function(pTab){
      pTab.addListener(lWidgetGroupListeners);
    });
    // For new tabs
    const lApplicationUIListeners = {
      onTabAdded : function (pTab) {
        pTab.addListener(lWidgetGroupListeners);
      }
    };
    pApplication.getUi().addListener(lApplicationUIListeners);

    //Listener Cleanup
    lAppListItem.on('remove', function() {
      pApplication.removeListener(lTreeViewListener);
      pApplication.getUi().listTabs().forEach(function(pTab){
        pTab.removeListener(lWidgetGroupListeners);
      });
      pApplication.getUi().removeListener(lApplicationUIListeners);
    });

    return {
      widget: lAppListItem,
      name: pApplication.getName(),
      controls: {
        open: lOpenOperatorUi
      }
    };
  }

  /**
   * Renders the Errors of a applications for the ErrorConsole tab in left Pane
   *
   * @param {machinelogic.Application} pApp
   * @param {Navigate} [pPendantNavigate] Required if running on the pendant
   * @returns {jQuery} JQuery Node
   */
  function applicationErrorsWidget(pApp, pPendantNavigate = undefined) {

    const lErrors = [];

    const lWidget = $('<div class="ml_app_error_widget">');
    const lContainer = $('<div>').css({display: 'flex', flexDirection: 'column'}).appendTo(lWidget);

    // Helper functions
    function lSelectError(pWidget, pError) {
      lContainer.find('.selected_error').removeClass('selected_error');
      pWidget.addClass('selected_error');
      pApp.mLibrary.selectApplicationByName(pError.app);
      pApp.selectSequenceByName(pError.seq);
    }

    function lPopulateOptions(pError, pOptionsWidget, pWidget) {
      pError.onError.options && pError.onError.options.forEach((pOption, pIndex, pOptions) => {
        // round the corners for the first and last options, special case for a single option
        let radius = 0;
        if (pOptions.length == 1) { radius = '5px'; }
        else if(0 === pIndex) { radius = '5px 5px 0 0'; }
        else if(pOptions.length - 1 === pIndex) { radius = '0 0 5px 5px'; }

        $('<div>')
          .css({
            'background-color': '#eff2f7',
            'padding': '5px',
            'border-radius': radius,
            'margin-bottom': '2px'
          })
          .append(
            $('<span>')
              .text(pOption.message)
              .css({ margin: '5px' }),
            pOption.target == 'none' ? null : $('<button class="ml_validator_fix_button">')
              .attr('hidden', pApp.isReadOnly() ? "hidden" : null)
              .text('Show')
              .css({'margin': '5px'})
              .on('mousedown', /* NOTE: the touch on the pendant registers mouseDown and touch but no mouseUp, which leads to the click event missing a lot of touch events */
                function(pEvent) {
                  if (pOption.target) {
                    // the button is also hidden, so this is not needed as such, keeping for the moment
                    // for read only apps,
                    // - we cant fix the config as the we wont be able to reselect the axis/ios
                    // - we cant fix the application.
                    if (pApp.isReadOnly()) {
                      $('.ml_editor').trigger('open_document', readOnlyDocument());
                      return;
                    }

                    if (pOption.target === 'redirect-config') {
                      const lMessage = {
                        header:       pError.header,
                        source:       pError.onError.message,
                        // Fortunately, all warnings related to the Configs end ups in the same way, we will remove the last part
                        // as this message will be shown in the Config page already
                        suggestion:   pOption.message.replace(/ in the Configuration tab.$/, '.'),
                        application:  pError.app,
                        sequence:     pError.seq,
                        instruction:  pError.index,
                      };

                      if (environment.isOnPendant()) {
                        pPendantNavigate({ pathname: "/machine-config", search: '?' + $.param({ warning: JSON.stringify(lMessage) }) });
                      }
                      else {
                        $('#machinelogic-configuration').trigger('click', [lMessage]);
                      }
                    }
                    else if (pOption.target === 'redirect-sequence') {
                      $(".show_tree_view_button").click();
                      //workaround for page load timing issue
                      setTimeout(() => {
                        const lAddSequenceBtn = $("#ml_button_add_sequence");
                        lAddSequenceBtn.addClass('ml_button_add_sequence_highlight');
                        setTimeout( function() { lAddSequenceBtn.removeClass('ml_button_add_sequence_highlight'); }, 10000 );
                      }, 0);
                    }
                    else if (pOption.target.includes('redirect-variables')) {
                      pEvent.stopPropagation();
                      highlightVariable(pApp, pOption.target.split('.')[1]);
                    }
                    else {
                      pEvent.stopPropagation();
                      lSelectError(pWidget, pError);
                      pApp.getSequence(pError.seq).setSelectedInstruction(pError.instruction, pOption.target ? pOption.target : true);
                    }
                  }
                  else {
                    console.log('notSupported', this);
                  }
                }
              )
          ).css({
            display: 'flex',
            'justify-content': 'space-between',
            'align-items': 'center',
          })
          .appendTo(pOptionsWidget);
      });
    }

    // gets the locally stored instance of the errors
    function findErrorWithSameSignatureFromLocalCache(pError) {
      return lErrors.find(function (pEl) {
        if (pEl.type === validatorErrorTypes.ApplicationError) {
          return pEl.key == pError.key;
        }
        else if (pEl.type === validatorErrorTypes.InstructionError) {
          return (pEl.instruction == pError.instruction) && (pEl.instructionSubResource == pError.instructionSubResource);
        }
        else {
          console.error(`validator error type ${pEl.type} not supported`);
        }
      });
    }

    function lBuildErrorCard(pError, pAllErrors) {
      const lWidget = $('<div>').css({position: 'relative'});
      $('<div class="ml_validator_checkmark">').css('display', 'none').append($('<div class="fas fa-exclamation"/>')).appendTo(lWidget);
      const lCard = $('<div class="ml_validator_error_card">').appendTo(lWidget);
      $('<div id="title">').text(pError.header).appendTo(lCard);
      $('<div id="subtitle">').text(pError.onError.message).appendTo(lCard);
      $('<div id="suggestions">').text('Ways to fix warning:').appendTo(lCard);
      const lOptions = $('<div id="options">').appendTo(lCard);
      lPopulateOptions(pError, lOptions, lWidget);

      lCard.click(function() {
        if(pApp.isReadOnly()) {
          $('.ml_editor').trigger('open_document', readOnlyDocument());
          return;
        }
        lSelectError(lWidget, pError);
        const lLibrary = pApp.mLibrary;
        const lSequence = pError.instruction.mSequence;
        const lSeqDocument = sequenceDocument(lLibrary, pApp, lSequence);
        $('.ml_editor').trigger('open_document', lSeqDocument);
        if(pError.type === ValidatorErrorTypes.ApplicationError) { return; } // do not correspond to instruction widget
        pApp.getSequence(pError.seq).setSelectedInstruction(pError.instruction, true);
      });

      lCard.mouseenter(
        function() {
          // highlight the instruction if possible, but dont scroll in
          // remove all highlighting
          $('.selected_error').removeClass('selected_error');
          $('.ml_card_erroneous').removeClass('ml_card_erroneous');
          $('.ml_card_selected').removeClass('ml_card_selected');

          lWidget.addClass('selected_error');

          // only highlight if the the app and the sequence is in view
          if(!pApp.mLibrary.getCurrentApplication()) { return; }
          if(pApp.mLibrary.getCurrentApplication().getName() != pError.app) { return; }
          if(!pApp.getCurrentSequence()) { /* we are most likely in Variables, we dont support highlighting variables yet */ return; }
          if(pApp.getCurrentSequence().getName() != pError.seq) { return; }

          pApp.getCurrentSequence().notify('onInstructionHighlighted', pError.instruction);
        }
      );

      // NOTE: Option 2 was implemented first, but user testing prefers Option 1,
      // NOTE: we will keep the option 2, but commented
      // OPTION 1: Keep error sorted by instruction order
      const index = pAllErrors.findIndex(function(pEl) { return pEl == pError; } );
      if(lContainer.children().length == 0) { lContainer.append(lWidget); }
      else if(index == 0) { lContainer.prepend(lWidget); }
      else { lContainer.children().eq(index - 1).after(lWidget); }

      // OPTION 2: New errors are added at the end.
      // lWidget.appendTo(lContainer);

      return lWidget;
    }

    function lResolveError(pError) {
      const lWidget = $(pError.widget);

      lWidget.removeClass('selected_error');
      const lWidgetCard = lWidget.find('.ml_validator_error_card').css({border: '1px solid #1AC876'});
      lWidget.find(".ml_validator_checkmark").show().empty().append($('<div class="fas fa-check"/>'));
      lWidget.addClass('resolve_error');
      lWidgetCard.find('#title').css({color: '#1AC876'});
      lWidgetCard.find('#subtitle').text(pError.onSuccess.message).css({color: '#1AC876'});
      lWidgetCard.find('#suggestions').remove();
      lWidgetCard.find('#options').remove();
      setTimeout( function() { lWidget.removeClass('resolve_error'); lWidget.addClass('remove_error'); }, 5000 );
      setTimeout( function() { lWidget.remove(); }, 7000 );
    }

    function lUpdateError(pUpdatedError) {
      const lWidget = $(pUpdatedError.widget);
      const lWidgetCard = lWidget.find('.ml_validator_error_card');
      lWidgetCard.find('#title').text(pUpdatedError.header);
      lWidgetCard.find('#subtitle').text(pUpdatedError.onError.message);
      const lOptions = lWidgetCard.find('#options').empty();
      lPopulateOptions(pUpdatedError, lOptions, lWidget);
    }

    // Application Listeners
    const lAppListeners = {
      onErrorResolved: (pResolvedError, pNewErrors) => {
        const lError = findErrorWithSameSignatureFromLocalCache(pResolvedError);
        lErrors.splice(lErrors.indexOf(lError), 1);
        lResolveError(lError);

        if ( pResolvedError.type === validatorErrorTypes.InstructionError) {
          const lOtherErrorOnSameInstruction = pNewErrors.some(function (pNewErrors) { return pNewErrors.instruction == pResolvedError.instruction; });
          if(lOtherErrorOnSameInstruction) { lAppListeners.onErrorUpdated(pResolvedError, lOtherErrorOnSameInstruction); }
        }

        if (lErrors.length == 0) { lWidget.css({display: 'none'}); } // hide widget if there are no errors
      },
      onErrorUpdated: (pError, pUpdatedError) => {
        const lError = findErrorWithSameSignatureFromLocalCache(pError);
        pUpdatedError.widget = lError.widget;
        lErrors[lErrors.indexOf(lError)] = pUpdatedError;
        lUpdateError(pUpdatedError);

      },
      onErrorCreated: (pError, pAllErrors) => {
        if (findErrorWithSameSignatureFromLocalCache(pError) != undefined) { return; } // do not add error if it already exists
        if (lErrors.length == 0) { lWidget.css({display: 'block'}); } // show widget if it was hidden before
        // NOTE: lErrors are not necessarily in the instruction order, it doesnt need to be, if you want to keep it ordered -> lErrors.splice(pError.index, 0, pError);
        lErrors.push(pError);
        pError.widget = lBuildErrorCard(pError, pAllErrors);
      }
    };
    pApp.addListener(lAppListeners);

    lWidget.on('remove', function callbackOnRemove() {
      pApp.removeListener(lAppListeners);
    });

    // Sequence Listeners;
    const lSequenceListeners = {
      onInstructionSelected: function(pInstruction, pErrorTarget) {
        if (pErrorTarget == undefined) {
          lContainer.find('.selected_error').removeClass('selected_error');
          if (pInstruction != null) {
            const lError = lErrors.find((ele)=>{  return (ele.instruction == pInstruction); });
            if (lError != undefined) {
              lError.widget.addClass('selected_error');
              lError.widget.get(0).scrollIntoView();
            }
          }
        }
      }
    };

    pApp.listSequences().forEach(function(pSeq){
      const lSeqObj = pApp.getSequence(pSeq);
      lSeqObj.addListener(lSequenceListeners);
      lWidget.on('remove', function callbackOnRemove() {
        lSeqObj.removeListener(lSequenceListeners);
      });
    });

    // init
    if (lErrors.length == 0) { lWidget.css({display: 'none'}); }

    pApp.mLibrary.getValidator().clearCacheForApp(pApp.getName());
    pApp.mLibrary.getValidator().validateApp(pApp);

    return lWidget;
  }

  /**
   * Highlights the variable in the application. Taken from
   * applicationTreeWidget and modified to work in isolation.
   * @param pApplication The application to highlight the variable in
   * @param pVariableName The variable name to highlight
   */
  function highlightVariable(pApplication, pVariableName) {
    const _lAppDocument = applicationDocument(pApplication);
    $('.ml_editor').trigger('open_document', _lAppDocument);

    // find the variable name id
    const lVariableKey = Object.values(pApplication.mParameters.mParameters).find(function(pEl) { return pVariableName == pEl.name; });
    const lSelectWidget = _lAppDocument.appParamCards[lVariableKey.id].find('.ml_parameter').find(`h5:contains("Input to track")`)
      .parent().parent().find('.ml_select_widget').find('select');
    lSelectWidget.addClass('ml_card_erroneous');
  }

  /**
   * @param {Object[]} robotConfigs list of robot configurations
   * @returns {boolean} to check if the robot configuration is valid
   */
  function isValidRobotConfig(robotConfigs) {
    return robotConfigs.some((robotConfig) => robotConfig.getType?.());
  }

  /**
   * Renders the entirety of the ui builder page
   *
   * @param {import('../machinelogic/Library').Library} pLibrary
   * @returns {JQuery}
   */
  function uiLibraryWidget(pLibrary, pUibuilerProps, pMachineAppProps) {
    const lUiWidgetList = [];
    const _lUIBuilderAppList = $('<ul>').addClass('ml_ui_tree_list');
    const _lLibraryListener = {
      onApplicationAdded : function(pApp, pIndex) {
        // Note (mkosarek 2021-05-19) This listener is only really useful in the pendant.
        // When we're in the pendant, we load the UI before the library officially loads.
        // When we load the library, we call "addApplication" which triggers this onApplicationAdded
        // listener to execute. Thus, we need this listener to handle the asynchronous nature
        // of library loading in pendant.
        //
        // Please note, however, that UI builder is not yet officially supported in pendant.
        // It might be supported in the future, so I will keep this code around because it
        // does not hurt.
        //
        const lUiWidget = uiTreeWidget(pLibrary, pApp, pUibuilerProps);
        if(undefined == pIndex || pIndex >= _lUIBuilderAppList.children().length) { // Children will always have "Configuration" first
          _lUIBuilderAppList.append(lUiWidget.widget);
          lUiWidgetList.push(lUiWidget);
        } else {
          $(_lUIBuilderAppList.children().get(pIndex)).before(lUiWidget.widget);
          lUiWidgetList.splice(pIndex, 0, lUiWidget);
        }
      }
    };
    const _lContainerTreeView = $('<div class="v_layout spaced">');

    // MachineLogic Applications
    const lPlayableApps = pLibrary.getAllApplications().filter(application => application.isPlayable);
    lPlayableApps.forEach(function(pApp) {
      const lWidget = uiTreeWidget(pLibrary, pApp, pUibuilerProps);
      _lUIBuilderAppList.append(lWidget.widget);                       // For UI builder editor
      lUiWidgetList.push(lWidget);
    });

    pLibrary.addListener(_lLibraryListener);
    _lUIBuilderAppList.on('remove', function onRemoveLibraryWidget() {
      pLibrary.removeListener(_lLibraryListener);
    });

    // Select a default document to show
    if (lUiWidgetList.length > 0) {
      let lCurrentApplication = pLibrary.getCurrentApplication();
      if (!lCurrentApplication && pUibuilerProps?.selectedApp) {
        const lApplicationWidget = lUiWidgetList.find(function(pWidget) { return pWidget.name === pUibuilerProps.selectedApp; });
        if (lApplicationWidget) {
          lCurrentApplication = pLibrary.getApplication(lApplicationWidget.name);
        }
      }

      const lWidgetToOpen = lCurrentApplication ? lUiWidgetList.find(pWidget => pWidget.name === lCurrentApplication.getName()) : lUiWidgetList[0];
      lWidgetToOpen.controls.open();
    }

    return environment.isOnPendant() ? _lContainerTreeView.append(_lUIBuilderAppList) : $('<div class="v_layout spaced">').append(_lUIBuilderAppList);
  }

  function reconnectWidget(pOnClick) {
    const _lWidget = $('<div class="ml_player h_layout spaced">');
    const _lMsg = $('<h5>Could not connect to MachineMotion</h5>');
    const _lReconnect = widgets.pushButton(null, icons.reconnect, 'Reconnect', pOnClick);

    _lWidget.append(_lMsg, _lReconnect);

    return _lWidget;
  }

  function applicationParameterWidget(pApplication, pParameter) {

    const lIcon = function () {
      if (pParameter.type == 'const') {
        const lIconType = icons.setVariable;
        return lIconType;
      } else if (pParameter.type == 'lambda') {
        const lIconType = icons.setVariable;
        return lIconType;
      } else if (pParameter.type == 'unpackConst') {
        const lIconType = icons.setVariable;
        return lIconType;
      } else {
        const lIconType = icons.setInputVariable;
        return lIconType;
      }
    };
    const lIconType = lIcon();

    const callbackOnClose = function () {
      pApplication.removeApplicationParameter(pParameter.id);
    };
    const lCard = widgets.card(lIconType, callbackOnClose);
    const lParameterObj = pApplication.getParametersObject();
    // Validation functions
    const required = function (value) { return value ? undefined : 'This field is required';};
    const isNameUsed = function (value) { return !lParameterObj.isNameUsed(value) ? undefined : 'Variable name is already used'; };
    const isValidVariableName = function (value) { return lParameterObj.isValidVariableName(value) ? undefined : 'Invalid name : avoid blank spaces, special characters and reserved keywords'; };
    const lParameterName = widgets.stringWidget(pParameter.type == "lambda" ? 'Function Name' : 'Variable Name', 'Name for variables', pParameter.name, function(pValue) {
      pApplication.updateApplicationParameter(pParameter.id, { name: pValue });
    }, [required, isNameUsed, isValidVariableName]);
    let lWidget;
    let lWidget2;
    const lockRemoveParameter = function() {
      lCard.blockOnClose();
      lCard.close.removeClass('ml_close').addClass('ml_locked ' + icons.locked).on('click.warning', function () {
        widgets.messageBox(`Before deleting ${pParameter.type}, "${pParameter.name}", remove it from instructions using it.`, 'warning');
      }).css({ 'margin-right': '0.25rem' });
    };
    const lApplicationListener = {
      onUpdated: function() {
        // lock remove parameter when updating application
        if (lParameterObj.isParameterUsed(pParameter.name)) {
          lockRemoveParameter();
        } else {
          lCard.unBlockOnClose();
          lCard.close.off('click.warning');
          lCard.close.addClass('ml_close').removeClass('ml_locked ' + icons.locked);
        }
      },
    };


    if (pParameter.type == 'const') {
      lWidget = autocompleteComponent(
        'Initial Value',
        'Variable initial value',
        pParameter.default_value,
        [],
        (pValue) => { pApplication.updateApplicationParameter(pParameter.id, {default_value:  pValue }); },
        [helpers.getExpressionValidationFunction(), required],
      ).widget;

      // Disable initial value field if UIB has a numericInput or dropdown connected to this variable.
      const lVariableInputWidgets = pApplication.getUi().listAllWidgets().filter(function(pWidget) { return pWidget.getType() == "numericInput" || pWidget.getType() == "dropdown"; });
      const lIsVariableSetbyWidget = lVariableInputWidgets.some(function(pWidget){return pWidget.getProps().variable == pParameter.name;});

      if (lIsVariableSetbyWidget) {
        lWidget.find('input').attr({ disabled:'disabled', title: "Variable's initial value is set by a UI Builder widget"}).css({ backgroundColor: 'rgb(231, 231, 231)', color: 'black', cursor: "default"});
        lWidget.find('input').parent().css({ backgroundColor: 'rgb(231, 231, 231)' }).on('click', function(){widgets.messageBox("Variable's initial value is set by a UI Builder widget", 'info');});
      }
    } else if (pParameter.type == 'lambda') {
      lWidget = widgets.stringWidget('Arguments', 'Function to be executed', pParameter.default_value.default_arguments, function(pValue) {
        pApplication.updateApplicationParameter(pParameter.id, {default_value: {default_arguments: pValue }});
      });
      lWidget2 = widgets.aceEditorWidget('Function', 'Function to be executed', pParameter.default_value.default_function,
        function(pValue) {
          pApplication.updateApplicationParameter(pParameter.id, {default_value: {default_function: pValue }});
        }, null, null, pParameter.id
      );
      // Note (AJ): We have to do this because the element aceEditor is searching for in the DOM is not in the DOM yet.
      // (it will only be added after we trigger open_document on the editor, which is the next block of logic in the same event loop).
      // By adding a setTimeout(0) we queue the function to be executed in the next event loop and this will ensure that applicationDocument is in the DOM
      // (by waiting for the previous event loop to complete execution) and the id the aceEditor is looking for should become available.
      setTimeout(() => { ilib_widgets.aceEditor( `aceWidget_${pParameter.id}`, pParameter.default_value.default_function); }, 0);
    } else {
      const lConfigManager = pApplication.mLibrary.getConfigManager();
      const lInput = lConfigManager.getInputByUuid(pParameter.inputUuid);
      const lDefaultValue = lInput ? lInput.getName() : '(Not Configured)';
      const lInputNamesList = lConfigManager.listInputs().map(function(pInput) { return pInput.getName(); });
      const lInputList = lInputNamesList.map(function(pName) { return { value: pName, text: pName };});
      if (!lInputNamesList.includes(lDefaultValue)) {
        lInputList.push( { value: lDefaultValue, text: lDefaultValue, deprecated: true } );
      }
      lWidget =  widgets.listWidget('Input to track', lInputList, 'Input', lDefaultValue, function(pValue) {
        const lInput = lConfigManager.getInputByName(pValue);
        lWidget.find('option[value="(Not Configured)"],option[disabled="disabled"]').remove(); // remove (Not Configured) if it is present
        pApplication.updateApplicationParameter(pParameter.id, { inputUuid: lInput.getUUID() });
        lWidget.getSelect().removeClass('ml_card_erroneous');
      });
    }

    // lock remove application parameter on initialization
    if (lParameterObj.isParameterUsed(pParameter.name)) {
      lockRemoveParameter();
    }

    pApplication.addListener(lApplicationListener);

    lCard.on('remove', function onRemoveAppParameter() {
      pApplication.removeListener(lApplicationListener);
    });

    lCard.parameters.append([lParameterName, lWidget, lWidget2]);
    lCard.css({ 'width': 'auto', 'margin-bottom': '5px' });

    return lCard;
  }

  const openDocument = (pApplication, focusedTab, focusedParam) => {
    if (focusedTab === 'robot') {
      openRobotDocument(pApplication);
      return;
    }

    const lAppDocument = applicationDocument(pApplication, focusedTab, focusedParam?.name);
    $('.ml_editor').trigger('open_document', lAppDocument);
  };

  const openRobotDocument = (pApplication) => {
    pApplication.selectSequenceByName(null);
    const lAppDocument = robotApplicationDocument(pApplication.mLibrary, pApplication, {
      robotConfigs: pApplication.mLibrary.getConfigManager().listRobots(),
      ...(environment.isOnCad() && { p3DContext: pApplication.mLibrary.m3DContext })
    }, function (pTabIndex) {
      gLastRobotAssetTabActive = pTabIndex;
    });
    lAppDocument.name = 'Robot Assets'; // The document.name is used to distinguish from the Variables & Functions document which also passes the application object
    $('.ml_editor').trigger('open_document', lAppDocument);
    lAppDocument.widget.find('ul').children().eq(gLastRobotAssetTabActive).click();
  };


  /* Module export glue */
  /* global define */
  const gExports = {
    editor: editor,
    baseWidget: widgets.baseWidget,
    card: widgets.card,
    icons : icons,
    listParameter: widgets.listWidget,
    numberParameter: widgets.numberWidget,
    playerWidget : view_widgets.playerWidget,
    pneumaticCommands: widgets.pneumaticCommands,
    reconnectWidget : reconnectWidget,
    stringParameter: widgets.stringWidget,
    applicationTreeWidget: applicationTreeWidget,
    showDriveSettingsModal: configurationEditor.showDriveSettingsModal,
    showApplyConfigurationModal: configurationEditor.showApplyConfigurationModal,
    formatAxisType: helpers.formatAxisType,
    showInstructionalModal: widgets.showInstructionalModal,
    readOnlyDocument: readOnlyDocument,
  };

  const gModule = typeof module;
  if (gModule !== 'undefined' && module.exports != undefined) {
    module.exports = gExports;
  } else if (define != undefined && typeof define === 'function' && define.amd) {
    define([], function () { return gExports; });
  }
}());

/**
 * Checks if the provided jQuery element ".sortable()" has been initialized.
 * Use this to check elements that are initialized conditionally before attempting to disable/enable/cancel the sortable.
 * (I don't fully understand jquery-ui's sortable, so this description might look confused, I'm sorry.)
 *
 * @param {jQuery} jQueryElement The jQuery element that we might want to call ".sortable(status)" on.
 * @return {boolean} True if the provided jQuery element ".sortable()" has been initialized.
 */
function isSortable(jQueryElement) {
  // The "ui-sortable" class is added by jQuery-ui when calling ".sortable(options)"
  return jQueryElement.hasClass('ui-sortable');
}
